window._aureaWorkerUrl = "https://aurea-r2-proxy.francis-340.workers.dev";
window._aureaBaseUrl = "https://ais-dev-z5ixoamyviyugiypm5prk3-15336112345.us-east1.run.app";
// Shopify Options Bridge (v1.3 - Refactored & Modularized)
(function () {
  if (window._aureaBridgeInitialized) return;
  window._aureaBridgeInitialized = true;

  // --- CORE SYSTEM STATE ---
  const fileUploads = {};
  const activeUploads = new Map();

  // --- DEEP DEBUG LOGGER ---
  const DEBUG = window.location.search.includes('aurea_debug=true') || window._aureaDebug;
  const AureaLog = {
    info(...args) { if (DEBUG) console.log("[Aurea Info]", ...args); },
    success(...args) { if (DEBUG) console.log("[Aurea Success]", ...args); },
    warn(...args) { console.warn("[Aurea Warn]", ...args); },
    error(...args) { console.error("[Aurea Error]", ...args); },
    trace(...args) { if (DEBUG) console.trace("[Aurea Trace]", ...args); }
  };
  window._aureaLog = AureaLog;
  // AureaLog.info("Auréa Options Bridge Initializing...");

  // 1. Capture base URL immediately
  let scriptSrc = "";
  if (document.currentScript && document.currentScript.src) {
    scriptSrc = document.currentScript.src;
  } else {
    const scripts = document.querySelectorAll("script");
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src.includes("/bridge.js")) {
        scriptSrc = scripts[i].src;
        break;
      }
    }
  }
  const baseUrl = scriptSrc ? scriptSrc.split("/bridge.js")[0] : "";
  window._aureaBaseUrl = window._aureaBaseUrl || baseUrl || window.location.origin;

  // --- 2. MODULAR STYLES & LAYOUTS ---
  const style = document.createElement("style");
  style.innerHTML = `
    .aurea-file-upload-wrapper { position: relative; margin-top: 8px; }
    .aurea-file-upload-btn {
      display: inline-flex; align-items: center; justify-content: center; gap: 8px;
      width: 100%; padding: 12px 16px; background: #ffffff; border: 1px solid #cbd5e1;
      border-radius: 8px; color: #334155; font-size: 14px; font-weight: 500;
      cursor: pointer; transition: all 0.2s ease; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    }
    .aurea-file-upload-btn:hover { background: #f8fafc; border-color: #94a3b8; }
    .aurea-file-upload-btn:active { background: #f1f5f9; transform: translateY(1px); }
    .aurea-file-upload-btn svg { width: 18px; height: 18px; color: #64748b; }
    .aurea-file-upload-progress { height: 4px; background: #e2e8f0; border-radius: 2px; margin-top: 12px; overflow: hidden; display: none; }
    .aurea-file-upload-bar { height: 100%; background: #0f172a; width: 0%; transition: width 0.3s ease; }
    .aurea-file-preview { margin-top: 12px; display: none; align-items: center; gap: 12px; padding: 10px; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0; }
    .aurea-file-preview img { width: 44px; height: 44px; object-fit: cover; border-radius: 6px; border: 1px solid #e2e8f0; }
    .aurea-file-preview-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
    .aurea-file-preview-name { font-size: 13px; font-weight: 600; color: #0f172a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .aurea-file-status-tag { font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; }
    .aurea-status-uploading { color: #2563eb; }
    .aurea-status-success { color: #16a34a; }
    .aurea-status-error { color: #dc2626; }

    .aurea-property-preview { display: block !important; width: 100% !important; flex-basis: 100% !important; clear: both !important; margin-top: 6px !important; margin-bottom: 6px !important; padding: 0 !important; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important; max-width: 100% !important; }
    .aurea-group-preview { margin-left: 0px !important; max-width: 100% !important; }
    .aurea-preview-card { display: inline-flex !important; align-items: center !important; gap: 10px !important; background: #f8fafc !important; border: 1px solid #e2e8f0 !important; border-radius: 8px !important; padding: 6px 12px !important; box-shadow: 0 1px 2px rgba(0,0,0,0.03) !important; max-width: 100% !important; box-sizing: border-box !important; overflow: hidden !important; cursor: pointer !important; margin: 4px 0 !important; transition: all 0.15s ease !important; }
    .aurea-preview-card:hover { background: #f1f5f9 !important; border-color: #cbd5e1 !important; }
    .aurea-cart-thumb-wrapper { width: 28px !important; height: 28px !important; border-radius: 4px !important; overflow: hidden !important; border: 1px solid #e2e8f0 !important; display: flex !important; align-items: center !important; justify-content: center !important; background-color: #ffffff !important; flex-shrink: 0 !important; margin: 0 !important; padding: 0 !important; }
    .aurea-cart-thumb-wrapper img { width: 100% !important; height: 100% !important; max-width: 100% !important; max-height: 100% !important; object-fit: cover !important; display: block !important; margin: 0 !important; padding: 0 !important; }
    .aurea-cart-thumb-wrapper svg { width: 20px !important; height: 20px !important; max-width: 20px !important; max-height: 20px !important; display: block !important; margin: 0 !important; padding: 0 !important; }
    .aurea-cart-fallback-div { width: 100% !important; height: 100% !important; display: none !important; margin: 0 !important; padding: 0 !important; align-items: center !important; justify-content: center !important; }
    .aurea-cart-fallback-div.show { display: flex !important; }
    .aurea-text-col { display: flex !important; flex-direction: column !important; justify-content: center !important; line-height: 1 !important; min-width: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important; }
    .aurea-filename-span { display: none !important; }
    .aurea-action-link { font-size: 12px !important; color: #2563eb !important; text-decoration: underline !important; font-weight: 500 !important; white-space: nowrap !important; display: inline-block !important; margin: 0 !important; padding: 0 !important; }
    
    .aurea-cart-group-header { display: block !important; font-weight: 600 !important; font-size: 13px !important; color: #1e293b !important; margin-top: 8px !important; margin-bottom: 4px !important; width: 100% !important; clear: both !important; }
    .aurea-cart-sub-label { display: block !important; font-weight: 500 !important; font-size: 12px !important; color: #475569 !important; margin-left: 0px !important; margin-bottom: 4px !important; margin-top: 4px !important; width: 100% !important; clear: both !important; }
    
    .custom-options-wrapper {
      margin: 24px 0 !important;
      padding: 24px !important;
      border: var(--aurea-wrapper-border, 1px solid #e2e8f0) !important;
      border-radius: 16px !important;
      background: var(--aurea-wrapper-bg, #ffffff) !important;
      box-shadow: var(--aurea-wrapper-shadow, 0 4px 24px rgba(0,0,0,0.02)) !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
      box-sizing: border-box !important;
    }
    .aurea-field { margin-bottom: 24px !important; }
    .aurea-label {
      display: block !important;
      font-weight: 700 !important;
      margin-bottom: 10px !important;
      font-size: 14px !important;
      color: var(--aurea-text-color, #0f172a) !important;
      letter-spacing: -0.01em !important;
    }
    .aurea-input {
      width: 100% !important;
      padding: 12px 16px !important;
      border: 1px solid #cbd5e1 !important;
      border-radius: 10px !important;
      background-color: #ffffff !important;
      color: var(--aurea-text-color, #0f172a) !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      box-sizing: border-box !important;
      outline: none !important;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02) !important;
    }
    .aurea-input:focus {
      border-color: #000000 !important;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05) !important;
    }
    select.aurea-input {
      appearance: none !important;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2024%2024%27%20fill%3D%27none%27%20stroke%3D%27%23475569%27%20stroke-width%3D%272%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%3E%3Cpolyline%20points%3D%276%209%2012%2015%2018%209%27%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 14px center !important;
      background-size: 16px !important;
      padding-right: 40px !important;
      cursor: pointer !important;
    }
    .aurea-input-textarea { min-height: 90px !important; resize: vertical !important; }
    
    .aurea-choice-group {
      display: flex !important;
      flex-direction: column !important;
      gap: 10px !important;
      width: 100% !important;
    }
    .aurea-choice-wrapper {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      cursor: pointer !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      color: #1e293b !important;
      padding: 12px 16px !important;
      border: 1px solid #e2e8f0 !important;
      border-radius: 10px !important;
      background: #ffffff !important;
      transition: all 0.2s ease !important;
      box-sizing: border-box !important;
      user-select: none !important;
    }
    .aurea-choice-wrapper:hover {
      border-color: #cbd5e1 !important;
      background: #f8fafc !important;
    }
    .aurea-choice-wrapper input[type="radio"],
    .aurea-choice-wrapper input[type="checkbox"] {
      width: 18px !important;
      height: 18px !important;
      accent-color: var(--aurea-primary-color, #000000) !important;
      cursor: pointer !important;
      margin: 0 !important;
    }
    .aurea-price-display { font-size: 1.2em !important; font-weight: bold !important; margin-bottom: 15px !important; display: none; color: var(--color-primary, #000) !important; }
    .aurea-error-box { color: #d93025 !important; padding: 12px !important; font-size: 13px !important; font-weight: bold !important; margin-bottom: 15px !important; border: 1px solid #d93025 !important; border-radius: 8px !important; }
    .aurea-file-group-container { display: flex !important; flex-direction: column !important; gap: 12px !important; padding: 16px !important; background: #f8fafc !important; border: 1px solid #e2e8f0 !important; border-radius: 12px !important; width: 100% !important; box-sizing: border-box !important; }
    .aurea-file-group-row { display: flex !important; flex-direction: column !important; gap: 6px !important; }
    .aurea-file-row-label { font-size: 12px !important; font-weight: 600 !important; color: #475569 !important; }
    
    /* Premium Styles for Card/Box Option Types */
    .aurea-cards-group.aurea-cards-layout-grid {
      display: grid !important;
      grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
      gap: 12px !important;
      margin-top: 8px !important;
      width: 100% !important;
    }
    .aurea-cards-group.aurea-cards-layout-full {
      display: flex !important;
      flex-direction: column !important;
      gap: 10px !important;
      margin-top: 8px !important;
      width: 100% !important;
    }
    @media (max-width: 480px) {
      .aurea-cards-group.aurea-cards-layout-grid {
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)) !important;
        gap: 8px !important;
      }
    }
    .aurea-card-option {
      position: relative !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: space-between !important;
      padding: 16px 18px !important;
      background: #ffffff !important;
      border: 1px solid #e2e8f0 !important;
      border-radius: 14px !important;
      cursor: pointer !important;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
      box-sizing: border-box !important;
      user-select: none !important;
      min-height: 96px !important;
    }
    .aurea-card-option:hover {
      border-color: #cbd5e1 !important;
      box-shadow: 0 4px 12px rgba(0,0,0,0.03) !important;
    }
    .aurea-card-option.is-selected {
      border: 2px solid var(--aurea-primary-color, #000000) !important;
      background: #ffffff !important;
      box-shadow: 0 6px 20px rgba(0,0,0,0.04) !important;
      padding: 15px 17px !important; /* adjust padding slightly to prevent jumping because of 2px border */
    }
    .aurea-card-option.is-selected::after {
      content: "" !important;
      position: absolute !important;
      top: 14px !important;
      right: 14px !important;
      width: 8px !important;
      height: 8px !important;
      background: var(--aurea-primary-color, #000000) !important;
      border-radius: 50% !important;
    }
    
    /* Styling adjustments when layout is full-width (stacked) */
    .aurea-cards-group.aurea-cards-layout-full .aurea-card-option {
      min-height: auto !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: space-between !important;
      padding: 18px 22px !important;
    }
    .aurea-cards-group.aurea-cards-layout-full .aurea-card-option.is-selected {
      padding: 17px 21px !important;
    }
    .aurea-cards-group.aurea-cards-layout-full .aurea-card-label {
      margin-bottom: 0 !important;
      font-size: 16px !important;
    }
    .aurea-cards-group.aurea-cards-layout-full .aurea-card-prices {
      margin-top: 0 !important;
      align-items: flex-end !important;
      text-align: right !important;
    }
    .aurea-cards-group.aurea-cards-layout-full .aurea-card-option.is-selected::after {
      top: 50% !important;
      right: 18px !important;
      transform: translateY(-50%) !important;
    }
    
    .aurea-card-label {
      font-size: 14px !important;
      font-weight: 800 !important;
      color: var(--aurea-text-color, #0f172a) !important;
      margin-bottom: 6px !important;
      line-height: 1.25 !important;
    }
    .aurea-card-prices {
      display: flex !important;
      flex-direction: column !important;
      gap: 2px !important;
      margin-top: auto !important;
    }
    .aurea-card-price-row {
      display: flex !important;
      align-items: baseline !important;
      flex-wrap: wrap !important;
      gap: 6px !important;
    }
    .aurea-card-current-price {
      font-size: 15px !important;
      font-weight: 800 !important;
      color: var(--aurea-text-color, #0f172a) !important;
    }
    .aurea-card-compare-price {
      font-size: 12px !important;
      text-decoration: line-through !important;
      color: #94a3b8 !important;
      font-weight: 400 !important;
    }
    .aurea-card-unit-price {
      font-size: 12px !important;
      color: #64748b !important;
      font-weight: 500 !important;
      margin-top: 2px !important;
    }
    .aurea-card-discount-badge {
      display: inline-block !important;
      align-self: flex-start !important;
      background: #fee2e2 !important;
      color: #ef4444 !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      padding: 3px 8px !important;
      border-radius: 6px !important;
      text-transform: uppercase !important;
      letter-spacing: 0.02em !important;
      margin-top: 4px !important;
      border: 1px solid #fee2e2 !important;
    }
  `;
  document.head.appendChild(style);

  // --- 3. UTILITIES NAMESPACE ---
  const AureaUtils = {
    getShop() {
      try {
        if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
        if (window.Shopify && window.Shopify.Domain) return window.Shopify.Domain;
        const metaShop = document.querySelector('meta[name="shopify-shop-domain"]');
        if (metaShop) return metaShop.content;

        const shopScript = Array.from(document.querySelectorAll("script")).find(
          (s) => s.src && s.src.includes("myshopify.com")
        );
        if (shopScript) {
          const url = new URL(shopScript.src);
          const s = url.searchParams.get("shop");
          if (s) return s;
        }

        const permanentLink = document.querySelector('link[rel="alternate"][href*=".myshopify.com"]');
        if (permanentLink) {
          const url = new URL(permanentLink.href);
          return url.hostname;
        }
        if (window.location.hostname.includes(".myshopify.com")) return window.location.hostname;
      } catch (e) {}
      return window.location.hostname;
    },

    getProductId() {
      // 0. ¡Chequeo instantáneo desde el bloque Custom Liquid!
      const nativeContainer = document.getElementById('aurea-native-options');
      if (nativeContainer && nativeContainer.dataset.productId) {
        return String(nativeContainer.dataset.productId);
      }

      // 1. Intentar desde objetos globales (Rápido si ya están cargados)
      if (window.meta && window.meta.product && window.meta.product.id) return String(window.meta.product.id);
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) return String(window.ShopifyAnalytics.meta.product.id);

      // 2. Intentar desde el DOM (¡Instantáneo en la mayoría de los temas modernos!)
      const section = document.querySelector('[data-product-id], [data-productid], [data-section-type="product"], product-info, .product[data-id]');
      if (section) {
        if (section.dataset.productId) return String(section.dataset.productId);
        if (section.dataset.productid) return String(section.dataset.productid);
        if (section.dataset.id) return String(section.dataset.id);
      }

      // 3. Intentar desde inputs ocultos en el formulario
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const hiddenInput = form.querySelector('input[name="product-id"], input[name="productId"]');
        if (hiddenInput && hiddenInput.value) return String(hiddenInput.value);
      }

      // 4. Intentar leer el JSON-LD estructurado (presente desde el primer milisegundo en el HTML)
      const jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
      for (let script of jsonLdScripts) {
        try {
          const data = JSON.parse(script.textContent);
          const items = Array.isArray(data) ? data : [data];
          for (let item of items) {
            if (item["@type"] === "Product") {
              if (item.productID) return String(item.productID);
              if (item["@id"]) {
                const match = item["@id"].match(/Product\/(\d+)/);
                if (match && match[1]) return match[1];
              }
            }
          }
        } catch (e) {}
      }

      return null;
    },

    getProductForm() {
      return document.querySelector('form[action*="/cart/add"], product-form form, .product-form form');
    },

    getSubmitBtnEl(form) {
      if (!form) return document.querySelector('[type="submit"], [name="add"], button.add-to-cart, .product-form__submit');
      return form.querySelector('[type="submit"], [name="add"], button.add-to-cart, .product-form__submit');
    },

    getFileIconSvg(filename) {
      const ext = String(filename).split(".").pop().toLowerCase();
      if (ext === "pdf") {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" style="border-radius:6px; overflow:hidden;"><rect width="24" height="24" fill="#EF4444" rx="4"/><text x="12" y="15" fill="white" font-family="Arial, Helvetica, sans-serif" font-weight="900" font-size="9" text-anchor="middle">PDF</text></svg>`;
      } else if (ext === "ai") {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" style="border-radius:6px; overflow:hidden;"><rect width="24" height="24" fill="#F59E0B" rx="4"/><text x="12" y="15" fill="#312E81" font-family="Arial, Helvetica, sans-serif" font-weight="900" font-size="10" text-anchor="middle">Ai</text></svg>`;
      } else if (ext === "psd") {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" style="border-radius:6px; overflow:hidden;"><rect width="24" height="24" fill="#2563EB" rx="4"/><text x="12" y="15" fill="#EFF6FF" font-family="Arial, Helvetica, sans-serif" font-weight="900" font-size="10" text-anchor="middle">Ps</text></svg>`;
      }
      return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:24px; height:24px;"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14.5 2 14.5 7.5 20 7.5"/></svg>`;
    },

    _moneyTemplate: null,
    _moneyDecimalSeparator: ".",
    _moneyThousandsSeparator: ",",

    guessMoneyFormatOnce() {
      if (this._moneyTemplate) return;

      let formatStr =
        window.theme?.moneyFormat ||
        window.theme?.money_format ||
        window.Shopify?.money_format ||
        window.Shopify?.moneyFormat;
      if (formatStr && formatStr.includes("{{")) {
        this._moneyTemplate = formatStr.replace(/<[^>]*>?/gm, "");
        return;
      }

      const shopifyPriceSelectors = [
        ".price-item--regular",
        ".product__price",
        ".price:not(.price--old) span",
        "[data-product-price]",
        ".current-price",
        "#ProductPrice",
        ".product-single__price",
        ".price__regular .price-item",
        ".product__details .price",
      ];

      for (let selector of shopifyPriceSelectors) {
        let els = document.querySelectorAll(selector);
        for (let el of els) {
          let txt = el.innerText.trim().replace(/\n/g, "").trim();
          let match = txt.match(/[\d]+(?:[.,][\d]{1,3})*(?:[.,][\d]{1,2})?/);
          if (match && parseFloat(match[0].replace(/[.,]/g, "")) >= 0) {
            let numStr = match[0];
            let hasDecimals = false;

            let lastSepMatch = numStr.match(/[.,](?=[\d]{1,2}$)/);
            if (lastSepMatch) {
              this._moneyDecimalSeparator = lastSepMatch[0];
              this._moneyThousandsSeparator = this._moneyDecimalSeparator === "." ? "," : ".";
              hasDecimals = true;
            }

            let token = "{{amount}}";
            if (!hasDecimals && txt.includes(numStr)) {
              token = "{{amount_no_decimals}}";
            } else if (this._moneyDecimalSeparator === ",") {
              token = "{{amount_with_comma_separator}}";
            }

            this._moneyTemplate = txt.replace(numStr, token);
            return;
          }
        }
      }

      this._moneyTemplate = "$ {{amount}}";
    },

    formatAureaMoney(amountDecimal) {
      this.guessMoneyFormatOnce();
      const cents = Math.round(amountDecimal * 100);
      let formatString =
        this._moneyTemplate ||
        window.theme?.moneyFormat ||
        window.Shopify?.money_format ||
        "${{amount}}";

      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, formatString).replace(/<[^>]*>?/gm, "");
      }

      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        precision = typeof precision === "undefined" ? 2 : precision;
        thousands = thousands || this._moneyThousandsSeparator;
        decimal = decimal || this._moneyDecimalSeparator;
        if (isNaN(number) || number == null) return "0";
        number = (number / 100.0).toFixed(precision);
        let parts = number.split(".");
        let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        let centsParam = parts[1] ? decimal + parts[1] : "";
        return dollars + centsParam;
      };

      let value = "";
      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let match = formatString.match(placeholderRegex);

      if (!match) {
        return new Intl.NumberFormat(window.Shopify?.locale || undefined, {
          style: "currency",
          currency: window.Shopify?.currency?.active || "USD",
        }).format(amountDecimal);
      }

      switch (match[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2, ",", ".");
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0, ",", ".");
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        default:
          value = formatWithDelimiters(cents, 2, ",", ".");
      }

      return formatString.replace(placeholderRegex, value).replace(/<[^>]*>?/gm, "");
    }
  };

  // --- 4. NETWORK CART INTERCEPTOR NAMESPACE ---
  const AureaCartInterceptor = {
    init() {
      if (window._aureaGlobalObserverAdded) return;
      window._aureaGlobalObserverAdded = true;

      const self = this;
      const originalFetch = window.fetch;
      window.fetch = async function (...args) {
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
        if (url.includes("/cart/add")) {
          AureaLog.info("Intercepted Fetch call to /cart/add", { url, options: args[1] });
          const oldBody = args[1] ? args[1].body : null;
          self.overwriteBodyVariant(args[1]);
          const newBody = args[1] ? args[1].body : null;
          AureaLog.info("Overwrote Fetch body variant ID", {
            lastVariantId: window._aureaLastVariantId,
            latestVariantId: window._aureaLatestVariantId,
            oldBody,
            newBody
          });
          
          let res;
          for (let i = 0; i < 15; i++) {
            AureaLog.info(`Executing actual Fetch call to /cart/add (Attempt ${i + 1}/15)...`);
            res = await originalFetch.apply(this, args);
            AureaLog.info(`Fetch call result (Attempt ${i + 1})`, { status: res.status, ok: res.ok });
            if (res.ok) {
              AureaLog.success(`Fetch /cart/add succeeded! Status: ${res.status}`);
              setTimeout(() => {
                AureaLog.info("Triggering form reset after successful fetch /cart/add");
                window.dispatchEvent(new CustomEvent("aurea:reset-forms"));
              }, 600);
              return res;
            }
            const clone = res.clone();
            if (clone.status === 422 || clone.status === 404) {
              const errorText = await clone.text();
              AureaLog.warn(`Fetch /cart/add failed with status ${clone.status}`, { errorText });
              if (
                errorText.toLowerCase().includes("sold out") ||
                errorText.toLowerCase().includes("unprocessable") ||
                clone.status === 404
              ) {
                AureaLog.info("Retrying fetch /cart/add in 1500ms...");
                await new Promise((r) => setTimeout(r, 1500));
                continue;
              }
            }
            return res;
          }
          return res;
        }
        return originalFetch.apply(this, args);
      };

      const originalXHR = window.XMLHttpRequest.prototype.send;
      window.XMLHttpRequest.prototype.send = function (body) {
        let finalBody = body;
        AureaLog.info("Intercepted XMLHttpRequest.send()", {
          originalBody: body,
          latestVariantId: window._aureaLatestVariantId
        });
        if (window._aureaLatestVariantId && body) {
          finalBody = self.overwriteRawVariant(body);
          AureaLog.info("Overwrote XHR body variant ID", {
            oldBody: body,
            newBody: finalBody
          });
        }

        this.addEventListener("load", function () {
          if (
            this.status >= 200 &&
            this.status < 300 &&
            this.responseURL &&
            this.responseURL.includes("/cart/add")
          ) {
            AureaLog.success(`XMLHttpRequest to /cart/add succeeded! Status: ${this.status}`, { url: this.responseURL });
            setTimeout(() => {
              AureaLog.info("Triggering form reset after successful XHR /cart/add");
              window.dispatchEvent(new CustomEvent("aurea:reset-forms"));
            }, 600);
          } else if (this.responseURL && this.responseURL.includes("/cart/add")) {
            AureaLog.warn(`XMLHttpRequest to /cart/add finished with non-success status: ${this.status}`, {
              url: this.responseURL,
              response: this.responseText
            });
          }
        });
        return originalXHR.call(this, finalBody);
      };
    },

    overwriteBodyVariant(options) {
      if (!window._aureaLatestVariantId) {
        AureaLog.warn("overwriteBodyVariant called but window._aureaLatestVariantId is null/undefined!");
        return;
      }
      if (!options || !options.body) return;
      try {
        let body = options.body;
        if (body instanceof FormData) {
          if (body.has("id")) {
            const oldId = body.get("id");
            body.set("id", window._aureaLatestVariantId);
            AureaLog.info(`FormData updated 'id' from ${oldId} to ${window._aureaLatestVariantId}`);
          } else {
            body.set("id", window._aureaLatestVariantId);
            AureaLog.info(`FormData added 'id' with value ${window._aureaLatestVariantId}`);
          }
        } else if (body instanceof URLSearchParams) {
          if (body.has("id")) {
            const oldId = body.get("id");
            body.set("id", window._aureaLatestVariantId);
            AureaLog.info(`URLSearchParams updated 'id' from ${oldId} to ${window._aureaLatestVariantId}`);
          } else {
            body.set("id", window._aureaLatestVariantId);
            AureaLog.info(`URLSearchParams added 'id' with value ${window._aureaLatestVariantId}`);
          }
        } else if (typeof body === "string") {
          options.body = this.overwriteRawVariant(body);
        }
      } catch (err) {
        AureaLog.error("Error overwriting body variant ID:", err);
      }
    },

    overwriteRawVariant(body) {
      if (typeof body !== "string") return body;
      try {
        if (body.trim().startsWith("{") || body.trim().startsWith("[")) {
          const data = JSON.parse(body);
          if (data.id) {
            const oldId = data.id;
            data.id = window._aureaLatestVariantId;
            AureaLog.info(`JSON payload updated 'id' from ${oldId} to ${window._aureaLatestVariantId}`);
            return JSON.stringify(data);
          } else if (data.items && Array.isArray(data.items)) {
            data.items.forEach((item, idx) => {
              if (item.id) {
                const oldId = item.id;
                item.id = window._aureaLatestVariantId;
                AureaLog.info(`JSON items[${idx}] updated 'id' from ${oldId} to ${window._aureaLatestVariantId}`);
              }
            });
            return JSON.stringify(data);
          }
        } else {
          const params = new URLSearchParams(body);
          if (params.has("id")) {
            const oldId = params.get("id");
            params.set("id", window._aureaLatestVariantId);
            AureaLog.info(`Form urlencoded raw body updated 'id' from ${oldId} to ${window._aureaLatestVariantId}`);
            return params.toString();
          }
        }
      } catch (err) {
        AureaLog.error("Error overwriting raw variant ID in body string:", err);
      }
      return body;
    }
  };

  // --- 5. DOM DECODER & OBSERVER NAMESPACE ---
  const AureaDOMProcessor = {
    decodeInvisibleString(text) {
      if (!text || !text.includes("\u200D\u200D\u200D")) return null;
      try {
        const idx = text.indexOf("\u200D\u200D\u200D");
        let endIdx = idx + 3;
        let binaryStr = "";
        while (endIdx < text.length) {
          const char = text[endIdx];
          if (char === "\u200C") binaryStr += "1";
          else if (char === "\u200B") binaryStr += "0";
          else break;
          endIdx++;
        }
        const domString = text.substring(idx, endIdx);
        const bytes = [];
        for (let i = 0; i < binaryStr.length; i += 8) {
          const byteStr = binaryStr.substring(i, i + 8);
          if (byteStr.length === 8) {
            bytes.push(parseInt(byteStr, 2));
          }
        }
        if (bytes.length > 0) {
          const url = new TextDecoder().decode(new Uint8Array(bytes));
          return { url, domString };
        }
      } catch (e) {}
      return null;
    },

    processCartElements() {
      const selectors = [
        ".product-option",
        ".cart-item__properties *",
        ".cart-item__property *",
        ".cart-item__details *",
        ".cart-notification-product__option *",
        ".product-meta-description *",
        ".checkout-item-property *",
        ".cart-drawer *",
        ".cart-items *",
        ".cart-item *",
        ".cart-notification *",
        ".cart__contents *",
        "#cart *",
        ".cart *",
      ];

      const query = selectors.map((s) => `${s}:not([data-aurea-processed])`).join(", ");
      const elements = document.querySelectorAll(query);

      elements.forEach((prop) => {
        if (prop.className && typeof prop.className === "string" && prop.className.includes("aurea-")) return;
        if (prop.closest(".aurea-property-preview") || prop.closest(".aurea-preview-card") || prop.closest(".aurea-file-upload-wrapper")) return;
        if (prop.parentElement && prop.parentElement.closest("[data-aurea-processed]")) return;

        let isGroupProperty = false;
        const findAndReplaceLabel = (node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.nodeValue;
            if (text.includes(" - ")) {
              const match = text.match(/(.*?)\s*-\s*([^:]+)(:?)/);
              if (match) {
                isGroupProperty = true;
                const mainTitle = match[1].trim();
                let cleanSub = match[2].trim();
                cleanSub = cleanSub.replace(/https?:\/\/[^\s<"';]+/g, "").trim();
                cleanSub = cleanSub.replace(/\[.*?\]/g, "").trim();
                cleanSub = cleanSub.replace(/\u200D/g, "").trim();
                cleanSub = cleanSub.replace(/[:\s,\-+]+$/, "").trim();

                if (cleanSub) {
                  const subTitle = cleanSub + (match[3] || "");
                  const wrapper = document.createElement("span");
                  wrapper.className = "aurea-cart-group-wrapper";
                  wrapper.dataset.aureaProcessed = "true";

                  const header = document.createElement("div");
                  header.className = "aurea-cart-group-header";
                  header.dataset.mainTitle = mainTitle;
                  header.innerText = mainTitle;

                  const subLabel = document.createElement("div");
                  subLabel.className = "aurea-cart-sub-label";
                  subLabel.innerText = subTitle;

                  wrapper.appendChild(header);
                  wrapper.appendChild(subLabel);

                  node.parentNode.replaceChild(wrapper, node);
                  return true;
                }
              }
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.className && typeof node.className === "string" && node.className.includes("aurea-")) {
              return false;
            }
            const children = Array.from(node.childNodes);
            for (let child of children) {
              if (findAndReplaceLabel(child)) {
                return true;
              }
            }
          }
          return false;
        };

        findAndReplaceLabel(prop);

        const text = prop.innerText || prop.textContent;
        const decoded = this.decodeInvisibleString(text);
        
        let decodedRawUrl = decoded ? decoded.url : null;
        let invisibleDOMString = decoded ? decoded.domString : null;

        if (!text || (!decodedRawUrl && !text.includes(".workers.dev") && !text.includes("drive.google.com") && !text.includes("view/"))) return;

        const children = prop.children;
        let childHasUrl = false;
        for (let i = 0; i < children.length; i++) {
          const childText = children[i].innerText || children[i].textContent;
          if (
            childText &&
            (childText.includes(".workers.dev") ||
              childText.includes("drive.google.com") ||
              childText.includes("view/") ||
              childText.includes("\u200D\u200D\u200D"))
          ) {
            childHasUrl = true;
            break;
          }
        }
        if (childHasUrl && !prop.matches("a")) return;

        prop.dataset.aureaProcessed = "true";
        const urlRegex = /(https?:\/\/[^\s<"';]+)/g;

        let uniqueUrls = [];
        let targetReplaceStrings = {};

        if (decodedRawUrl) {
          uniqueUrls.push(decodedRawUrl);
          if (text.includes("[Archivo adjunto]" + invisibleDOMString)) {
            targetReplaceStrings[decodedRawUrl] = "[Archivo adjunto]" + invisibleDOMString;
          } else {
            targetReplaceStrings[decodedRawUrl] = invisibleDOMString;
          }
        } else {
          const allMatches = text.match(urlRegex) || [];
          if (allMatches.length === 0) return;
          uniqueUrls = [...new Set(allMatches)];
          uniqueUrls.forEach((u) => (targetReplaceStrings[u] = u));
        }

        uniqueUrls.forEach((rawUrl) => {
          const domString = targetReplaceStrings[rawUrl];
          let fileUrl = rawUrl.replace(/[.,:;)]+$/, "");
          if (!fileUrl.startsWith("http")) fileUrl = "https://" + fileUrl;
          fileUrl = fileUrl.replace(/https:\/\/https:\/\//g, "https://");

          let fileId = "";
          let isR2 = false;

          if (fileUrl.includes("drive.google.com")) {
            const match = fileUrl.match(/id=([a-zA-Z0-9_-]+)/);
            if (match && match[1]) fileId = match[1];
          } else if (fileUrl.includes("view/")) {
            const match = fileUrl.match(/\/view\/([a-zA-Z0-9_-]+)/);
            if (match && match[1]) {
              fileId = match[1];
              isR2 = true;
            }
          }

          if (!fileId) return;

          const container = document.createElement("div");
          container.className = "aurea-property-preview";
          if (isGroupProperty) {
            container.classList.add("aurea-group-preview");
          }
          container.dataset.aureaProcessed = "true";

          const previewCard = document.createElement("div");
          previewCard.className = "aurea-preview-card";
          previewCard.dataset.aureaProcessed = "true";

          const mediaWrapper = document.createElement("div");
          mediaWrapper.className = "aurea-cart-thumb-wrapper";
          mediaWrapper.dataset.aureaProcessed = "true";

          const img = document.createElement("img");
          img.dataset.aureaProcessed = "true";

          if (isR2) {
            img.src = fileUrl;
          } else {
            img.src = `https://lh3.googleusercontent.com/u/0/d/${fileId}=w100-h100-p`;
          }

          const fallbackDiv = document.createElement("div");
          fallbackDiv.className = "aurea-cart-fallback-div";
          fallbackDiv.dataset.aureaProcessed = "true";
          fallbackDiv.innerHTML = AureaUtils.getFileIconSvg("");

          img.onerror = () => {
            img.style.setProperty("display", "none", "important");
            fallbackDiv.classList.add("show");
          };

          mediaWrapper.appendChild(img);
          mediaWrapper.appendChild(fallbackDiv);

          const textCol = document.createElement("div");
          textCol.className = "aurea-text-col";
          textCol.dataset.aureaProcessed = "true";

          const fileNameSpan = document.createElement("span");
          fileNameSpan.className = "aurea-filename-span";
          fileNameSpan.dataset.aureaProcessed = "true";
          fileNameSpan.innerText = "Cargando...";

          const actionLink = document.createElement("a");
          actionLink.className = "aurea-action-link";
          actionLink.dataset.aureaProcessed = "true";
          let downloadUrl = fileUrl;
          if (isR2 && downloadUrl.includes("?key=")) {
            downloadUrl = downloadUrl.split("?key=")[0];
          }
          if (isR2 && downloadUrl.includes("&key=")) {
            downloadUrl = downloadUrl.split("&key=")[0];
          }

          actionLink.href = isR2 ? downloadUrl : `https://drive.google.com/uc?export=download&id=${fileId}`;
          actionLink.target = "_blank";
          actionLink.innerText = "Ver Adjunto";

          textCol.appendChild(actionLink);
          textCol.appendChild(fileNameSpan);

          previewCard.appendChild(mediaWrapper);
          previewCard.appendChild(textCol);
          container.appendChild(previewCard);

          previewCard.onclick = (e) => {
            if (e.target !== actionLink) {
              window.open(actionLink.href, "_blank");
            }
          };

          if (prop.tagName.toLowerCase() === "a") {
            prop.style.display = "none";
            if (prop.parentNode) prop.parentNode.insertBefore(container, prop.nextSibling);
          } else {
            let aTagFound = false;
            const aTags = prop.querySelectorAll("a");
            for (let a of aTags) {
              if (
                a.href.includes(fileId) ||
                a.innerText.includes(fileId) ||
                a.href.includes(rawUrl) ||
                a.innerText.includes(domString)
              ) {
                a.style.display = "none";

                let prefix = "";
                const aText = a.innerText || a.textContent || "";
                const idxOfUrl = aText.indexOf(domString);
                if (idxOfUrl > 0) {
                  prefix = aText.substring(0, idxOfUrl).trim();
                } else if (
                  !aText.startsWith("http") &&
                  !aText.includes(".workers.dev") &&
                  !aText.includes("drive.google.com") &&
                  !aText.includes("\u200D\u200D\u200D")
                ) {
                  prefix = aText;
                }
                prefix = prefix.replace(/[:\s,\-+]+$/, "").trim();
                if (prefix && prefix.length < 100) {
                  const labelTextNode = document.createTextNode(prefix + ": ");
                  a.parentNode.insertBefore(labelTextNode, a);
                }

                a.parentNode.insertBefore(container, a.nextSibling);
                aTagFound = true;
                break;
              }
            }

            if (!aTagFound) {
              const walk = document.createTreeWalker(prop, NodeFilter.SHOW_TEXT, null, false);
              let n;
              let textNodeFound = false;
              while ((n = walk.nextNode())) {
                if (n.nodeValue.includes(domString)) {
                  const parts = n.nodeValue.split(domString);
                  const parent = n.parentNode;
                  parts.forEach((part, idx) => {
                    parent.insertBefore(document.createTextNode(part), n);
                    if (idx < parts.length - 1) {
                      const hiddenSpan = document.createElement("span");
                      hiddenSpan.style.display = "none";
                      hiddenSpan.innerText = domString;
                      hiddenSpan.dataset.aureaProcessed = "true";
                      parent.insertBefore(hiddenSpan, n);
                    }
                  });
                  parent.removeChild(n);
                  textNodeFound = true;
                  break;
                }
              }

              if (!textNodeFound) {
                const htmlEscapedUrl = domString.replace(/&/g, "&amp;");
                if (prop.innerHTML.includes(domString)) {
                  prop.innerHTML = prop.innerHTML.replace(
                    domString,
                    `<span style="display:none;" data-aurea-processed="true">${domString}</span>`
                  );
                } else if (prop.innerHTML.includes(htmlEscapedUrl)) {
                  prop.innerHTML = prop.innerHTML.replace(
                    htmlEscapedUrl,
                    `<span style="display:none;" data-aurea-processed="true">${htmlEscapedUrl}</span>`
                  );
                }
              }
              prop.appendChild(container);
            }
          }

          let appBaseUrl = window._aureaBaseUrl || "";
          let workerUrl = window._aureaWorkerUrl;
          let metaFetchUrl = "";
          if (workerUrl) {
            if (!workerUrl.startsWith("http")) workerUrl = "https://" + workerUrl;
            metaFetchUrl = `${workerUrl}/api/file-metadata/${fileId}`;
          } else if (appBaseUrl) {
            metaFetchUrl = `${appBaseUrl}/api/file-metadata/${fileId}`;
          } else {
            metaFetchUrl = `/api/file-metadata/${fileId}`;
          }

          fetch(metaFetchUrl)
            .then((res) => {
              if (!res.ok) throw new Error();
              return res.json();
            })
            .then((meta) => {
              if (meta && meta.originalName) {
                fileNameSpan.innerText = meta.originalName;
                actionLink.title = meta.originalName;

                const ext = meta.originalName.split(".").pop().toLowerCase();
                const isImg = ["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(ext);

                if (!isImg) {
                  img.style.setProperty("display", "none", "important");
                  fallbackDiv.classList.add("show");
                  fallbackDiv.innerHTML = AureaUtils.getFileIconSvg(meta.originalName);
                } else if (!isR2) {
                  img.src = meta.driveLink || img.src;
                }
              } else {
                fileNameSpan.innerText = "Archivo Adjunto";
              }
            })
            .catch(() => {
              fileNameSpan.innerText = "Archivo Adjunto";
              try {
                const parsedUrl = new URL(fileUrl);
                const urlFilename = parsedUrl.searchParams.get("fileName") || parsedUrl.searchParams.get("filename");
                if (urlFilename) fileNameSpan.innerText = decodeURIComponent(urlFilename);
              } catch (e) {}
            });
        });
      });

      // RUN DEDUPLICATION OF HEADERS HERE!
      const cartItems = document.querySelectorAll(".cart-item, .cart-drawer__item, .cart-item__details, tr, li, [data-cart-item]");
      cartItems.forEach((cartItem) => {
        const seenTitles = new Set();
        const headers = cartItem.querySelectorAll(".aurea-cart-group-header");
        headers.forEach((header) => {
          const title = (header.getAttribute("data-main-title") || header.innerText || "").trim();
          if (title) {
            if (seenTitles.has(title)) {
              header.style.setProperty("display", "none", "important");
              header.style.setProperty("margin-top", "0px", "important");
            } else {
              seenTitles.add(title);
              header.style.setProperty("display", "block", "important");
            }
          }
        });
      });
    },

    observeCart() {
      this.processCartElements();
      let observerTimeout = null;
      const observer = new MutationObserver(() => {
        if (observerTimeout) return;
        observerTimeout = setTimeout(() => {
          observerTimeout = null;
          const isUploading = Array.from(activeUploads.values()).some((d) => d.status === "uploading");
          let globalIndicator = document.getElementById("aurea-global-upload-progress");

          if (isUploading) {
            const cartContainers = document.querySelectorAll(
              ".cart-drawer__footer, .cart__footer, .cart-drawer__header, .cart__contents"
            );
            if (cartContainers.length > 0 && !globalIndicator) {
              globalIndicator = document.createElement("div");
              globalIndicator.id = "aurea-global-upload-progress";
              globalIndicator.style.padding = "10px";
              globalIndicator.style.background = "#eff6ff";
              globalIndicator.style.borderBottom = "1px solid #bfdbfe";
              globalIndicator.style.fontSize = "12px";
              globalIndicator.style.color = "#1e40af";
              globalIndicator.innerHTML = `<strong>Subiendo archivos...</strong> No cierres la ventana.`;
              cartContainers[0].prepend(globalIndicator);
            }
          } else if (globalIndicator) {
            globalIndicator.remove();
          }

          this.processCartElements();
        }, 150); // Throttle
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  // --- 6. FILE UPLOAD MECHANICS NAMESPACE ---
  const AureaUploadManager = {
    async handleFileUpload(file, fieldId, propName) {
      if (!file) return;

      const inputElement = document.querySelector(`input[name="${propName}"]`);
      const container = inputElement
        ? inputElement.closest(".aurea-file-upload-wrapper")
        : document.getElementById(`upload-container-${fieldId}`);

      if (!container) return;
      const progressBar = container.querySelector(".aurea-file-upload-progress");
      const bar = container.querySelector(".aurea-file-upload-bar");
      const preview = container.querySelector(".aurea-file-preview");
      const previewName = container.querySelector(".aurea-file-preview-name");
      const statusTag = container.querySelector(".aurea-file-status-tag");
      const previewImg = preview.querySelector("img");

      progressBar.style.display = "block";
      bar.style.width = "0%";
      preview.style.display = "flex";
      previewName.innerText = file.name;
      statusTag.innerText = "Subiendo...";
      statusTag.className = "aurea-file-status-tag aurea-status-uploading";

      if (file.type.startsWith("image/")) {
        previewImg.src = URL.createObjectURL(file);
      } else {
        previewImg.src =
          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z'%3E%3C/path%3E%3Cpolyline points='14.5 2 14.5 7.5 20 7.5'%3E%3C/polyline%3E%3C/svg%3E";
      }

      const shop = AureaUtils.getShop();
      const productId = AureaUtils.getProductId();

      activeUploads.set(propName, { status: "uploading", progress: 0 });

      try {
        const uploadPromise = new Promise(async (resolve, reject) => {
          try {
            let cartToken = localStorage.getItem("aurea_upload_token");
            if (!cartToken) {
              cartToken = Math.random().toString(36).substring(2) + Date.now().toString(36);
              localStorage.setItem("aurea_upload_token", cartToken);
            }

            let url, fileId, publicUrl;
            let workerUrl = window._aureaWorkerUrl;
            if (workerUrl && !workerUrl.startsWith("http")) workerUrl = "https://" + workerUrl;

            if (workerUrl) {
              workerUrl = workerUrl.replace(/\/$/, "");
              fileId = "aurea-" + Date.now() + "-" + Math.random().toString(36).substring(2, 8);
              const uploadParams = new URLSearchParams({
                token: cartToken,
                filename: file.name,
                shop: shop
              });
              if (productId) uploadParams.set("productId", productId);
              
              url = `${workerUrl}/upload/${fileId}?${uploadParams.toString()}`;
              publicUrl = `${workerUrl}/view/${fileId}?token=${cartToken}`;
            } else {
              const urlParams = new URLSearchParams({
                fileName: file.name,
                shop,
                productId: productId || "",
                cartToken,
                contentType: file.type || "application/octet-stream",
              });

              const presignRes = await fetch(`${window._aureaBaseUrl}/api/s3/presigned-url?${urlParams}`);
              if (!presignRes.ok) throw new Error("No se pudo obtener la URL firmada");
              const presignData = await presignRes.json();
              url = presignData.url;
              fileId = presignData.fileId;
              publicUrl = presignData.publicUrl;
            }

            const xhr = new XMLHttpRequest();
            xhr.open("PUT", url);
            xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");

            xhr.upload.onprogress = (e) => {
              if (e.lengthComputable) {
                const percent = Math.round((e.loaded / e.total) * 100);
                bar.style.width = percent + "%";
                activeUploads.get(propName).progress = percent;

                window.dispatchEvent(
                  new CustomEvent("aurea:upload-progress", {
                    detail: { propName, percent, fileName: file.name },
                  })
                );
              }
            };

            xhr.onload = () => {
              if (xhr.status >= 200 && xhr.status < 300) {
                bar.style.width = "100%";
                fileUploads[propName] = publicUrl;
                statusTag.innerText = "¡Listo!";
                statusTag.className = "aurea-file-status-tag aurea-status-success";
                activeUploads.get(propName).status = "success";

                window.dispatchEvent(
                  new CustomEvent("aurea:upload-complete", {
                    detail: { propName, fileId, fileName: file.name },
                  })
                );
                resolve(fileId);
              } else {
                reject(new Error("Error en la subida directo a R2, código " + xhr.status));
              }
            };

            xhr.onerror = () => reject(new Error("Error de red en la subida a R2"));
            xhr.send(file);
          } catch (err) {
            reject(err);
          }
        });
        
        return await uploadPromise.catch((e) => {
          AureaLog.error("Upload error caught in outer catch:", e);
          statusTag.innerText = "Error";
          statusTag.className = "aurea-file-status-tag aurea-status-error";
          activeUploads.get(propName).status = "error";
          progressBar.style.display = "none";
          bar.style.width = "0%";
        });
      } catch (e) {
        AureaLog.error("Upload error caught in outermost catch:", e);
        statusTag.innerText = "Error";
        statusTag.className = "aurea-file-status-tag aurea-status-error";
        activeUploads.get(propName).status = "error";
        progressBar.style.display = "none";
        bar.style.width = "0%";
      }
    }
  };
  window._handleFileUpload = AureaUploadManager.handleFileUpload;

  // --- 7. OPTIONS & PRICES LAYOUT NAMESPACE ---
  const AureaOptionsManager = {
    init() {
      const nativeContainer = document.getElementById('aurea-native-options');
      const isProductPage = window.location.pathname.includes('/products/');

      // ¡CRÍTICO! Si no es página de producto y no hay bloque nativo, NO HACER NADA.
      // Esto evita que las opciones aparezcan en el Home o en colecciones.
      if (!isProductPage && !nativeContainer) return;

      const forms = document.querySelectorAll('form[action*="/cart/add"]:not(.installment)');
      const productId = AureaUtils.getProductId();

      if (!productId) return;

      if (forms.length > 0 && isProductPage) {
        forms.forEach((form) => {
          if (!form._aureaInitialized) {
            form._aureaInitialized = true;
            this.setupForm(form, productId);
          }
        });
      } else if (nativeContainer && !nativeContainer._aureaInitialized) {
        nativeContainer._aureaInitialized = true;
        this.setupForm(null, productId);
      }
    },

    setupForm(form, productId) {
      const shop = AureaUtils.getShop();
      
      // --- NUEVO: CHEQUEO INSTANTÁNEO DE CONFIGURACIÓN NATIVA ---
      const nativeConfigScript = document.getElementById('aurea-native-config');
      if (nativeConfigScript && nativeConfigScript.textContent) {
        try {
          let parsedConfig = JSON.parse(nativeConfigScript.textContent);
          let actualConfig = parsedConfig.config ? parsedConfig.config : parsedConfig;
          
          if (actualConfig && actualConfig.fields) {
             // Shopify ya nos dio la config. Renderizar inmediatamente sin red.
             this.renderOptions(form, actualConfig, productId);
             return;
          }
        } catch(e) { AureaLog.error("Error parsing native config", e); }
      }
      // ---------------------------------------------------------

      const loadAndRender = () => {
        const handleLoadedConfig = (config) => {
          if (!config) {
            if (typeof window._aureaUnhidePrices === "function") window._aureaUnhidePrices();
            return;
          }
          this.renderOptions(form, config, productId);
        };

        if (window._aureaProductConfig) {
          let actualConfig = window._aureaProductConfig.config ? window._aureaProductConfig.config : window._aureaProductConfig;
          handleLoadedConfig(actualConfig);
          return;
        }

        const cacheKey = `aurea_config_${productId}`;
        const isPreview = window.location.search.includes("preview=true") || window.location.search.includes("draft=true");
        let cachedConfig = null;
        if (!isPreview) {
          try {
            const cached = localStorage.getItem(cacheKey);
            if (cached) {
              const parsed = JSON.parse(cached);
              // Cache for 1 hour instead of 5 seconds to prevent slow loading on every page view
              if (parsed && Date.now() - parsed.timestamp < 3600000) {
                cachedConfig = parsed.config;
                handleLoadedConfig(parsed.config);
                // Return if cache is fresh (< 5 mins), otherwise fetch in background (stale-while-revalidate)
                if (Date.now() - parsed.timestamp < 300000) return;
              }
            }
          } catch (e) {}
        }

        let workerUrl = window._aureaWorkerUrl;
        if (workerUrl && !workerUrl.startsWith("http")) workerUrl = "https://" + workerUrl;

        const configUrl = workerUrl
          ? `${workerUrl}/api/shopify/product-config?productId=${productId}&shop=${shop}`
          : `${window._aureaBaseUrl}/api/shopify/product-config?productId=${productId}&shop=${shop}`;

        fetch(configUrl)
          .then((res) => res.json())
          .then((data) => {
            if (data && data.config) {
              if (!isPreview) {
                try {
                  localStorage.setItem(cacheKey, JSON.stringify({ config: data.config, timestamp: Date.now() }));
                } catch (e) {}
              }
              // Only call handleLoadedConfig if we didn't already render from cache, or if the config changed (simplified by just re-rendering)
              if (!cachedConfig || JSON.stringify(cachedConfig) !== JSON.stringify(data.config)) {
                handleLoadedConfig(data.config);
              }
            }
          })
          .catch(() => {});
      };

      // Run loadAndRender immediately! Do not block options rendering on any network request
      loadAndRender();

      // Fetch settings asynchronously in the background only if hideExtraPrice is not already set on window
      if (shop && typeof window._aureaHideExtraPrice === "undefined") {
        const cacheKey = `aurea_hide_extra_${shop}`;
        try {
          const cached = localStorage.getItem(cacheKey);
          if (cached) {
            const parsed = JSON.parse(cached);
            if (Date.now() - parsed.timestamp < 86400000) { // 24h
              window._aureaHideExtraPrice = parsed.value;
            }
          }
        } catch(e) {}
        
        fetch(`${window._aureaBaseUrl}/api/shopify/hide-extra-price?shop=${shop}`)
          .then((res) => res.json())
          .then((data) => {
            if (data && typeof data.hideExtraPrice !== "undefined") {
              const oldVal = window._aureaHideExtraPrice;
              window._aureaHideExtraPrice = data.hideExtraPrice;
              try {
                localStorage.setItem(cacheKey, JSON.stringify({ value: data.hideExtraPrice, timestamp: Date.now() }));
              } catch(e) {}
              // If the value changed, trigger re-render to update price displays
              if (oldVal !== data.hideExtraPrice && window._aureaProductConfig) {
                loadAndRender();
              }
            }
          })
          .catch(() => {});
      }
    },

    evaluateConditions(visibilityObj, allValues) {
      if (!visibilityObj || !visibilityObj.conditions || visibilityObj.conditions.length === 0) return true;
      let allTrue = true;
      let anyTrue = false;

      visibilityObj.conditions.forEach((c) => {
        const targetVal = allValues[c.fieldId] || "";
        const v1 = String(targetVal).toLowerCase().trim();
        const v2 = String(c.value || "").toLowerCase().trim();

        let isMatch = false;
        if (c.operator === "equals") isMatch = v1 === v2;
        else if (c.operator === "notEquals") isMatch = v1 !== v2;
        else if (c.operator === "contains") isMatch = v1.includes(v2);

        if (!isMatch) allTrue = false;
        if (isMatch) anyTrue = true;
      });

      const conditionsMet = visibilityObj.matchType === "any" ? anyTrue : allTrue;
      return visibilityObj.action === "show" ? conditionsMet : !conditionsMet;
    },

    updateMainImage(imageUrl) {
      if (!imageUrl) return;
      const possibleSelectors = [
        '.product__media img', 
        '.product-single__photo img', 
        '.product-featured-media img', 
        '.product-image-main img',
        'img.product-single__thumbnail-image'
      ];
      
      let found = false;
      for (const selector of possibleSelectors) {
         const els = document.querySelectorAll(selector);
         if (els.length > 0) {
            els.forEach(el => {
              if (el.tagName === 'IMG') {
                el.src = imageUrl;
                if (el.srcset) {
                   el.srcset = imageUrl;
                }
              }
            });
            found = true;
            break;
         }
      }
      
      if (!found) {
         const form = AureaUtils.getProductForm();
         if (form) {
            const productRoot = form.closest('.product') || form.closest('.product-single') || document;
            const images = productRoot.querySelectorAll('img');
            let largestImg = null;
            let maxArea = 0;
            images.forEach(img => {
               const area = img.clientWidth * img.clientHeight;
               if (area > maxArea) {
                  maxArea = area;
                  largestImg = img;
               }
            });
            if (largestImg) {
               largestImg.src = imageUrl;
               if (largestImg.srcset) {
                  largestImg.srcset = imageUrl;
               }
            }
         }
      }
    },

    renderOptions(form, config, productId) {
      let hideExtra = true;
      if (typeof window._aureaHideExtraPrice !== "undefined" && window._aureaHideExtraPrice !== null && window._aureaHideExtraPrice !== "") {
        hideExtra = !(window._aureaHideExtraPrice === false || window._aureaHideExtraPrice === "false" || window._aureaHideExtraPrice === 0 || window._aureaHideExtraPrice === "0");
      } else if (config && typeof config.hideExtraPrice !== "undefined" && config.hideExtraPrice !== null) {
        hideExtra = !(config.hideExtraPrice === false || config.hideExtraPrice === "false" || config.hideExtraPrice === 0 || config.hideExtraPrice === "0");
      }

      let stickyPrice = false;
      if (typeof window._aureaStickyPrice !== "undefined" && window._aureaStickyPrice !== null && window._aureaStickyPrice !== "") {
        stickyPrice = (window._aureaStickyPrice === true || window._aureaStickyPrice === "true" || window._aureaStickyPrice === 1 || window._aureaStickyPrice === "1");
      } else if (config && typeof config.stickyPrice !== "undefined" && config.stickyPrice !== null) {
        stickyPrice = (config.stickyPrice === true || config.stickyPrice === "true" || config.stickyPrice === 1 || config.stickyPrice === "1");
      }

      const fields = config.fields || [];
      if (fields.length === 0 && !stickyPrice) return;

      const formId = form ? (form.getAttribute("id") || "aurea-form-" + Math.floor(Math.random() * 10000)) : "aurea-form-" + Math.floor(Math.random() * 10000);
      if (form) form.setAttribute("id", formId);

      const containerId = "custom-options-container-" + formId;
      let container = document.getElementById(containerId) || document.getElementById("aurea-native-options");
      let isNative = false;

      if (container && container.getAttribute("data-aurea-native") === "true") {
        isNative = true;
      } else {
        let nativeContainer = document.getElementById("aurea-native-options");
        if (nativeContainer) {
          if (container && container !== nativeContainer) container.remove();
          container = nativeContainer;
          // NO cambiamos el ID para que el Editor de Temas de Shopify no pierda la referencia (recuadro azul)
          container.setAttribute("data-aurea-native", "true");
          container.style.display = "block";
          isNative = true;

          // Remover listeners inline temporales si existen para que bridge.js asuma el control limpio
          if (container._inlineListenersAdded && typeof window._aureaApplyInlineVisibility === "function") {
            container.removeEventListener("change", window._aureaApplyInlineVisibility);
            container.removeEventListener("input", window._aureaApplyInlineVisibility);
          }
        } else {
          // Si no se encuentra aurea-native-options, verificar si existe algún contenedor nativo ya reclamado por otro formulario para clonarlo
          const existingNative = document.querySelector('[data-aurea-native="true"]');
          if (existingNative && existingNative.id !== containerId) {
            if (container) container.remove();
            container = existingNative.cloneNode(true);
            container.id = containerId;
            container.setAttribute("data-aurea-native", "true");
            container.removeAttribute("data-aurea-initialized"); // Asegurar que se re-vinculen los listeners en el clon
            container.style.display = "block";
            isNative = true;
          } else {
            if (!container) {
              container = document.createElement("div");
              container.id = containerId;
              container.className = "custom-options-wrapper";
            } else {
              container.innerHTML = "";
            }
          }
        }
      }

      const isPreview = window.location.search.includes("preview=true") || window.location.search.includes("draft=true") || (window.Shopify && window.Shopify.designMode);
      if (isNative && container.getAttribute("data-aurea-initialized") === "true" && !isPreview) {
        AureaLog.info("Contenedor nativo de opciones de Auréa ya inicializado en este formulario. Evitando re-render para carga instantánea 0ms.");
        // Si es nativo, no lo movemos.
        if (typeof window._aureaUnhidePrices === "function") window._aureaUnhidePrices();
        return;
      }

      if (fields.length === 0) {
        container.style.display = "none";
      }

      const fieldElements = new Map();
      const fieldInputs = new Map();

      window.addEventListener("aurea:reset-forms", () => {
        _resetAllFields();
      });

      const priceDisplayId = "aurea-dynamic-price-" + formId;
      let priceDisplayEl = container.querySelector(".aurea-price-display") || document.getElementById(priceDisplayId);
      if (!priceDisplayEl) {
        priceDisplayEl = document.createElement("div");
        priceDisplayEl.id = priceDisplayId;
        priceDisplayEl.className = "aurea-price-display";
        container.appendChild(priceDisplayEl);
      } else {
        priceDisplayEl.id = priceDisplayId;
      }

      const globalPriceInputId = "aurea-global-price-adj-" + formId;
      let globalPriceInput = container.querySelector('input[name="properties[_SystemPriceAdjustment]"]') || document.getElementById(globalPriceInputId);
      if (!globalPriceInput) {
        globalPriceInput = document.createElement("input");
        globalPriceInput.type = "hidden";
        globalPriceInput.id = globalPriceInputId;
        globalPriceInput.name = "properties[_SystemPriceAdjustment]";
        globalPriceInput.setAttribute("form", formId);
        container.appendChild(globalPriceInput);
      } else {
        globalPriceInput.id = globalPriceInputId;
        globalPriceInput.setAttribute("form", formId);
      }

      // Clean up previous sticky mobile bar and its scroll listener
      const existingStickyId = "aurea-sticky-price-mobile-" + formId;
      const oldSticky = document.getElementById(existingStickyId);
      if (oldSticky) {
        if (oldSticky._scrollListener) {
          window.removeEventListener("scroll", oldSticky._scrollListener);
        }
        oldSticky.remove();
      }

      // Sticky price mobile initialization
      let stickyMobileEl = null;
      if (stickyPrice) {
        stickyMobileEl = document.createElement("div");
        stickyMobileEl.id = existingStickyId;
        stickyMobileEl.className = "aurea-sticky-price-mobile";
        
        // Add CSS styling dynamically
        const styleId = "aurea-sticky-price-style";
        let styleEl = document.getElementById(styleId);
        if (!styleEl) {
          styleEl = document.createElement("style");
          styleEl.id = styleId;
          styleEl.innerHTML = `
            .aurea-sticky-price-mobile {
              position: fixed;
              bottom: 0;
              left: 0;
              width: 100%;
              background: #ffffff;
              box-shadow: 0 -4px 16px rgba(0,0,0,0.08);
              z-index: 2147483647;
              padding: 12px 20px;
              display: none;
              justify-content: space-between;
              align-items: center;
              box-sizing: border-box;
              border-top: 1px solid #f1f5f9;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
              transition: transform 0.3s ease, opacity 0.3s ease;
            }
            @media (max-width: 767px) {
              .aurea-sticky-price-mobile.is-visible {
                display: flex !important;
              }
            }
            .aurea-sticky-price-mobile-label {
              font-size: 11px;
              color: #64748b;
              text-transform: uppercase;
              letter-spacing: 0.05em;
              font-weight: 600;
              margin-bottom: 2px;
            }
            .aurea-sticky-price-mobile-val {
              font-size: 20px;
              font-weight: 800;
              color: #0f172a;
            }
            .aurea-sticky-price-mobile-compare {
              font-size: 14px;
              text-decoration: line-through;
              color: #94a3b8;
              margin-left: 6px;
              font-weight: 400;
            }
            .aurea-sticky-price-mobile-btn {
              background: #0f172a;
              color: #ffffff;
              border: none;
              padding: 10px 18px;
              font-weight: 700;
              font-size: 13px;
              border-radius: 8px;
              cursor: pointer;
              box-shadow: 0 2px 4px rgba(0,0,0,0.04);
              transition: background 0.2s, transform 0.1s;
            }
            .aurea-sticky-price-mobile-btn:active {
              transform: scale(0.97);
            }
          `;
          document.head.appendChild(styleEl);
        }

        const infoCol = document.createElement("div");
        infoCol.style.display = "flex";
        infoCol.style.flexDirection = "column";

        const labelEl = document.createElement("div");
        labelEl.className = "aurea-sticky-price-mobile-label";
        labelEl.innerText = "Price";
        infoCol.appendChild(labelEl);

        const valContainer = document.createElement("div");
        valContainer.className = "aurea-sticky-price-mobile-val-container";
        infoCol.appendChild(valContainer);

        stickyMobileEl.appendChild(infoCol);

        const actionBtn = document.createElement("button");
        actionBtn.type = "button";
        actionBtn.className = "aurea-sticky-price-mobile-btn";
        actionBtn.innerText = "Add to Cart";
        actionBtn.addEventListener("click", () => {
          const actualForm = form || AureaUtils.getProductForm();
          const submitBtn = actualForm ? actualForm.querySelector('[type="submit"], [name="add"], button.add-to-cart, .product-form__submit') : document.querySelector('[type="submit"], [name="add"], button.add-to-cart, .product-form__submit');
          if (submitBtn) {
            submitBtn.scrollIntoView({ behavior: "smooth", block: "center" });
            submitBtn.style.transform = "scale(1.05)";
            setTimeout(() => { if (submitBtn) submitBtn.style.transform = ""; }, 300);
          }
        });
        stickyMobileEl.appendChild(actionBtn);

        document.body.appendChild(stickyMobileEl);

        let scrollListener = () => {
          if (window.innerWidth >= 768) {
            stickyMobileEl.classList.remove("is-visible");
            return;
          }
          const actualForm = form || AureaUtils.getProductForm();
          const rect = actualForm ? actualForm.getBoundingClientRect() : { top: 0 };
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if ((actualForm && rect.top < 0) || (!actualForm && scrollTop > 150)) {
            stickyMobileEl.classList.add("is-visible");
          } else {
            stickyMobileEl.classList.remove("is-visible");
          }
        };
        window.addEventListener("scroll", scrollListener);
        stickyMobileEl._scrollListener = scrollListener;
      }

      const updatePriceUI = (finalPrice, finalCompareAt) => {
        const formatted = AureaUtils.formatAureaMoney(finalPrice);
        const formattedCompareAt = finalCompareAt ? AureaUtils.formatAureaMoney(finalCompareAt) : null;
        let found = false;

        const productRoot = form ? (form.closest('.product') || 
                            form.closest('.product-single') || 
                            form.closest('product-info') || 
                            form.closest('.product-section') || 
                            form.closest('.shopify-section') || 
                            document) : document;

        const isRelatedProduct = (el) => {
          return !!el.closest('.related-products, .product-recommendations, #related-products, .recommendations, .similar-products, .up-sell, .cross-sell, [class*="recommendation"], [class*="related"], [id*="recommendation"], [id*="related"]');
        };

        if (!document.getElementById("aurea-hide-from-style")) {
          const style = document.createElement("style");
          style.id = "aurea-hide-from-style";
          style.innerHTML = `
            .price__from, .price-item--from, .price-from, .from-text, 
            .product-price__from, .price__label, .price-label, 
            [class*="price-from"], [class*="price__from"], [class*="from-text"],
            [class*="price-label"] {
              display: none !important;
              visibility: hidden !important;
              opacity: 0 !important;
            }
          `;
          (document.head || document.documentElement).appendChild(style);
        }

        const cleanFromElementsAndText = (rootEl) => {
          if (!rootEl) return;
          const targetSelectors = [
            '.price__from', '.price-item--from', '.price-from', 
            '.from-text', '.product-price__from', '.price__label',
            '.price-label', '[class*="price-from"]', '[class*="price__from"]',
            '[class*="from-text"]', '[class*="price-label"]'
          ];
          targetSelectors.forEach(sel => {
            rootEl.querySelectorAll(sel).forEach(el => {
              el.style.setProperty('display', 'none', 'important');
            });
          });

          rootEl.querySelectorAll('span, div, p, label, small, b, strong, s').forEach(el => {
            const txt = (el.textContent || '').trim();
            if (/^(From|from|Desde|desde)\s*:?$/i.test(txt)) {
              el.style.setProperty('display', 'none', 'important');
              el.textContent = '';
            }
          });

          const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null, false);
          let node;
          const nodesToReplace = [];
          while (node = walker.nextNode()) {
            const text = node.nodeValue;
            if (/\b(From|from|Desde|desde)\b/i.test(text)) {
              nodesToReplace.push({ node, newValue: text.replace(/\b(From|from|Desde|desde)\s*:?\s*/ig, "") });
            }
          }
          nodesToReplace.forEach(({ node, newValue }) => {
            node.nodeValue = newValue;
          });
        };

        cleanFromElementsAndText(productRoot);

        productRoot.querySelectorAll(".price").forEach((priceContainer) => {
          if (isRelatedProduct(priceContainer)) return;
          if (finalCompareAt) priceContainer.classList.add("price--on-sale");
          else priceContainer.classList.remove("price--on-sale");
          cleanFromElementsAndText(priceContainer);
        });

        const regularPriceItems = productRoot.querySelectorAll(".price-item--regular");
        const salePriceItems = productRoot.querySelectorAll(".price-item--sale");

        if (regularPriceItems.length > 0 || salePriceItems.length > 0) {
          regularPriceItems.forEach((el) => {
            if (isRelatedProduct(el)) return;
            el.innerText = finalCompareAt ? formattedCompareAt : formatted;
            el.style.transition = "color 0.2s ease";
            el.style.color = "#4f46e5";
            setTimeout(() => { if (el) el.style.color = ""; }, 1000);
            found = true;
            cleanFromElementsAndText(el.parentElement);
          });

          salePriceItems.forEach((el) => {
            if (isRelatedProduct(el)) return;
            if (finalCompareAt) {
              el.innerText = formatted;
              el.style.transition = "color 0.2s ease";
              el.style.color = "#4f46e5";
              setTimeout(() => { if (el) el.style.color = ""; }, 1000);
              found = true;
              cleanFromElementsAndText(el.parentElement);
            }
          });
        }

        const fallbackSelectors = [
          ".product__price", ".current-price", "#ProductPrice",
          ".product-single__price", ".product__details .price"
        ];

        fallbackSelectors.forEach((selector) => {
          productRoot.querySelectorAll(selector).forEach((el) => {
            if (isRelatedProduct(el)) return;
            if (
              !el.querySelector(".price-item--regular") &&
              !el.querySelector(".price-item--sale")
            ) {
              if (finalCompareAt) {
                el.innerHTML = `<span class="price-item price-item--sale">${formatted}</span> <s class="price-item price-item--regular" style="opacity: 0.6; font-size: 0.9em; margin-left: 8px;">${formattedCompareAt}</s>`;
              } else {
                el.innerText = formatted;
              }
              el.style.transition = "color 0.2s ease";
              el.style.color = "#4f46e5";
              setTimeout(() => { if (el) el.style.color = ""; }, 1000);
              found = true;
              cleanFromElementsAndText(el);
              cleanFromElementsAndText(el.parentElement);
            }
          });
        });

        if (priceDisplayEl) {
          if (found) {
            priceDisplayEl.style.display = "none";
          } else {
            if (finalCompareAt) {
              priceDisplayEl.innerHTML = `<span style="font-size: 1.25em; font-weight: bold; color: #000;">${formatted}</span> <span style="text-decoration: line-through; color: #888; margin-left: 8px;">${formattedCompareAt}</span>`;
            } else {
              priceDisplayEl.innerHTML = `<span style="font-size: 1.25em; font-weight: bold; color: #000;">${formatted}</span>`;
            }
            priceDisplayEl.style.display = "block";
          }
          priceDisplayEl.setAttribute("data-absolute-price", finalPrice);
        }
        if (stickyMobileEl) {
          const valContainer = stickyMobileEl.querySelector(".aurea-sticky-price-mobile-val-container");
          if (valContainer) {
            if (finalCompareAt) {
              valContainer.innerHTML = `<span class="aurea-sticky-price-mobile-val">${formatted}</span><span class="aurea-sticky-price-mobile-compare">${formattedCompareAt}</span>`;
            } else {
              valContainer.innerHTML = `<span class="aurea-sticky-price-mobile-val">${formatted}</span>`;
            }
          }
        }
        if (globalPriceInput) globalPriceInput.value = finalPrice.toFixed(2);
      };

      const updateVisibility = () => {
        const allSelectedValues = {};
        const selections = [];

        fields.forEach((f) => {
          const input = fieldInputs.get(f.id);
          if (input) {
            if (input.type === "radio") {
              const checked = container.querySelector(`[name="properties[${f.label}]"]:checked`);
              allSelectedValues[f.id] = checked ? checked.value : "";
            } else if (input.type === "checkbox") {
              allSelectedValues[f.id] = input.checked ? input.value : "";
            } else if (input.type === "hidden") {
              allSelectedValues[f.id] = input.value;
            } else {
              allSelectedValues[f.id] = input.value;
            }
          }

          const val = allSelectedValues[f.id];
          if (val) {
            if (f.type === "checkbox_group" && f.choices) {
              const checkedList = val.split(",").map((v) => v.trim());
              checkedList.forEach((cv) => {
                const choice = f.choices.find((c) => String(c.label).trim() === String(cv).trim());
                if (choice) {
                  selections.push({ fieldId: f.id, value: cv, choiceId: choice.id });
                }
              });
            } else {
              const choice = f.choices?.find((c) => String(c.label).trim() === String(val).trim());
              selections.push({ fieldId: f.id, value: val, choiceId: choice ? choice.id : null });
            }
          }
        });

        let isAvailable = true;

        fields.forEach((f) => {
          const fieldEl = fieldElements.get(f.id);
          if (!fieldEl) return;

          const isFieldVisible = f.visibility ? this.evaluateConditions(f.visibility, allSelectedValues) : true;
          fieldEl.style.setProperty("display", isFieldVisible ? "block" : "none", "important");

          const fieldInputsInWrapper = fieldEl.querySelectorAll("input, select, textarea");
          fieldInputsInWrapper.forEach((inp) => { inp.disabled = !isFieldVisible; });

          if (!isFieldVisible) return;

          if (f.type === "dropdown" || f.type === "radio" || f.type === "cards") {
            if (f.type === "dropdown") {
              const select = fieldEl.querySelector("select");
              if (select) {
                Array.from(select.options).forEach((opt) => {
                  if (opt.value === "") return;
                  const choiceDef = f.choices.find((c) => c.label === opt.value);
                  if (!choiceDef) return;

                  const isChoiceVisible = choiceDef.visibility ? this.evaluateConditions(choiceDef.visibility, allSelectedValues) : true;
                  opt.style.setProperty("display", isChoiceVisible ? "block" : "none", "important");
                  opt.disabled = !isChoiceVisible;

                  if (!isChoiceVisible && opt.selected) {
                    opt.selected = false;
                    select.value = "";
                    setTimeout(updateVisibility, 0);
                  }
                });
              }
            } else if (f.type === "radio") {
              (f.choices || []).forEach((choice) => {
                const radioWrapper = fieldEl.querySelector(`[data-choice-label="${choice.label}"]`);
                if (radioWrapper) {
                  const isChoiceVisible = choice.visibility ? this.evaluateConditions(choice.visibility, allSelectedValues) : true;
                  radioWrapper.style.setProperty("display", isChoiceVisible ? "flex" : "none", "important");

                  const rInput = radioWrapper.querySelector("input");
                  if (!isChoiceVisible && rInput && rInput.checked) {
                    rInput.checked = false;
                    setTimeout(updateVisibility, 0);
                  }
                }
              });
            } else if (f.type === "cards") {
              (f.choices || []).forEach((choice) => {
                const cardWrapper = fieldEl.querySelector(`[data-choice-label="${choice.label}"]`);
                if (cardWrapper) {
                  const isChoiceVisible = choice.visibility ? this.evaluateConditions(choice.visibility, allSelectedValues) : true;
                  cardWrapper.style.setProperty("display", isChoiceVisible ? "flex" : "none", "important");

                  const rInput = cardWrapper.querySelector("input");
                  if (!isChoiceVisible && rInput && rInput.checked) {
                    rInput.checked = false;
                    cardWrapper.classList.remove("is-selected");
                    setTimeout(updateVisibility, 0);
                  }
                }
              });
            }
          } else if (f.type === "checkbox_group") {
            (f.choices || []).forEach((choice) => {
              const cbWrapper = fieldEl.querySelector(`[data-choice-label="${choice.label}"]`);
              if (cbWrapper) {
                const isChoiceVisible = choice.visibility ? this.evaluateConditions(choice.visibility, allSelectedValues) : true;
                cbWrapper.style.setProperty("display", isChoiceVisible ? "flex" : "none", "important");

                const cbInput = cbWrapper.querySelector("input");
                if (!isChoiceVisible && cbInput && cbInput.checked) {
                  cbInput.checked = false;
                  const hiddenInput = fieldEl.querySelector('input[type="hidden"]');
                  if (hiddenInput) {
                    const checkedValues = Array.from(fieldEl.querySelectorAll('input[type="checkbox"]:checked')).map((cb) => cb.value);
                    hiddenInput.value = checkedValues.join(", ");
                  }
                  setTimeout(updateVisibility, 0);
                }
              }
            });
          } else if (f.type === "file_group") {
            (f.choices || []).forEach((choice) => {
              const rowWrapper = fieldEl.querySelector(`.aurea-file-group-row[data-choice-label="${choice.label}"]`);
              if (rowWrapper) {
                const isChoiceVisible = choice.visibility ? this.evaluateConditions(choice.visibility, allSelectedValues) : true;
                rowWrapper.style.setProperty("display", isChoiceVisible ? "flex" : "none", "important");

                const fInput = rowWrapper.querySelector("input[type='file']");
                if (fInput) {
                  fInput.disabled = !isChoiceVisible;
                  if (!isChoiceVisible && fInput.files && fInput.files.length > 0) {
                    fInput.value = "";
                    const uploadContainer = rowWrapper.querySelector(".aurea-file-upload-wrapper");
                    if (uploadContainer) {
                      const preview = uploadContainer.querySelector(".aurea-file-preview");
                      if (preview) {
                        preview.style.display = "none";
                        const img = preview.querySelector("img");
                        if (img) img.src = "";
                        const name = preview.querySelector(".aurea-file-preview-name");
                        if (name) name.innerText = "";
                      }
                      const uploadBtn = uploadContainer.querySelector(".aurea-file-upload-btn");
                      if (uploadBtn) uploadBtn.style.display = "flex";
                      const progress = uploadContainer.querySelector(".aurea-file-upload-progress");
                      if (progress) progress.style.display = "none";
                      const bar = uploadContainer.querySelector(".aurea-file-upload-bar");
                      if (bar) bar.style.width = "0%";
                    }
                    delete fileUploads[fInput.name];
                    activeUploads.delete(fInput.name);
                  }
                }
              }
            });
          }
        });

        try {
          let targetVariantId = "";
          const form = AureaUtils.getProductForm();
          if (form) {
            const idInputs = form.querySelectorAll('[name="id"]');
            if (idInputs.length > 0) {
              for (let input of idInputs) {
                if (!input.disabled && input.value) {
                  targetVariantId = input.dataset.aureaOriginalId || input.value;
                  break;
                }
              }
            }
          }
          if (!targetVariantId) {
            const urlParams = new URLSearchParams(window.location.search);
            targetVariantId = urlParams.get("variant");
          }
          if (!targetVariantId && window.meta?.product?.variants) {
            targetVariantId = window.meta.product.variants[0].id;
          }

          AureaLog.info("=== START LOCAL PRICE CALCULATION ===");
          AureaLog.info(`Active target Variant ID: ${targetVariantId}`);

          let robustBasePrice = 0;
          if (config.pricingRules) {
            for (const rule of config.pricingRules) {
                if (rule.action === 'set_base') {
                    robustBasePrice = parseFloat(rule.value || 0);
                }
            }
          }
          if (robustBasePrice === 0 && window.meta?.product?.variants) {
            const matching = window.meta.product.variants.find(v => String(v.id) === String(targetVariantId));
            if (matching) {
              robustBasePrice = matching.price / 100;
            } else if (window.meta.product.variants[0]) {
              robustBasePrice = window.meta.product.variants[0].price / 100;
            }
          }
          if (robustBasePrice === 0) {
            const analyticsVariants = window.ShopifyAnalytics?.meta?.product?.variants;
            if (analyticsVariants) {
              const matching = analyticsVariants.find(v => String(v.id) === String(targetVariantId));
              if (matching) {
                robustBasePrice = matching.price / 100;
              } else if (analyticsVariants[0]) {
                robustBasePrice = analyticsVariants[0].price / 100;
              }
            }
          }
          if (robustBasePrice === 0) {
            const shopifyPriceSelectors = [
              ".price-item--regular",
              ".product__price",
              ".price:not(.price--old) span",
              "[data-product-price]",
              ".current-price",
              "#ProductPrice",
              ".product-single__price",
              ".price__regular .price-item",
              ".product__details .price"
            ];
            for (let selector of shopifyPriceSelectors) {
              let el = document.querySelector(selector);
              if (el) {
                let txt = el.innerText.trim().replace(/\n/g, "").trim();
                let match = txt.match(/[\d]+(?:[.,][\d]{1,3})*(?:[.,][\d]{1,2})?/);
                if (match) {
                  let val = parseFloat(match[0].replace(/,/g, ""));
                  if (!isNaN(val) && val > 0) {
                    robustBasePrice = val;
                    break;
                  }
                }
              }
            }
          }
          AureaLog.info(`Resolved Base State from Config/Fallback: Price=${robustBasePrice}`);

          let ruleExtraSum = 0;
          let currentBasePrice = robustBasePrice;
          let matchedPricingRuleDiscount = null;

          AureaLog.info(`Starting price calculations with Base Price: ${currentBasePrice}`);

          const pricingRules = config.pricingRules || [];
          for (const rule of pricingRules) {
            if (!rule.conditions || rule.conditions.length === 0) continue;

            const isMatch = rule.conditions.every((c) =>
              selections.some((s) => {
                const fieldEl = fieldElements.get(s.fieldId);
                if (!fieldEl || fieldEl.style.display === "none") return false;
                if (s.fieldId !== c.fieldId) return false;
                const sVal = String(s.value).toLowerCase().trim();
                const cVal = String(c.value).toLowerCase().trim();
                if (sVal === cVal) return true;
                if (s.choiceId && c.value && String(s.choiceId) === String(c.value)) return true;
                return false;
              })
            );

            if (isMatch) {
              AureaLog.info(`Pricing Rule Matched!`, rule);
              if (rule.action === "set_base") {
                currentBasePrice = parseFloat(rule.value || 0);
                AureaLog.info(`Rule Action: set_base. Base price updated to: ${currentBasePrice}`);
              } else if (rule.action === "add") {
                ruleExtraSum += parseFloat(rule.value || 0);
                AureaLog.info(`Rule Action: add. Adding ${rule.value}. Accumulator extra sum: ${ruleExtraSum}`);
              } else {
                currentBasePrice = parseFloat(rule.value || 0);
                AureaLog.info(`Rule Action: fallback set. Base price updated to: ${currentBasePrice}`);
              }

              if (rule.discountValue && rule.discountType) {
                matchedPricingRuleDiscount = { type: rule.discountType, value: rule.discountValue };
                AureaLog.info(`Rule Discount:`, matchedPricingRuleDiscount);
              }
            }
          }

          let priceAdjustmentTotal = 0;
          let selectedImageUrl = null;
          selections.forEach((sel) => {
            const f = fields.find((field) => field.id === sel.fieldId);
            if (f) {
              const fieldEl = fieldElements.get(f.id);
              if (fieldEl && fieldEl.style.display !== "none") {
                const choice = f.choices?.find((c) => 
                  String(c.label).trim().toLowerCase() === String(sel.value).trim().toLowerCase() ||
                  (sel.choiceId && String(c.id).trim() === String(sel.choiceId).trim())
                );
                if (choice) {
                  if (choice.priceAdjustment) {
                    const adj = parseFloat(choice.priceAdjustment);
                    priceAdjustmentTotal += adj;
                    AureaLog.info(`Choice Price Adjustment: Option field '${f.label}' - choice '${choice.label}' has price adjustment: +${adj}. Current adj sum: ${priceAdjustmentTotal}`);
                  }
                  if (choice.imageUrl && choice.imageUrl !== 'none') {
                    selectedImageUrl = choice.imageUrl;
                  }
                }
              }
            }
          });

          if (selectedImageUrl) {
            this.updateMainImage(selectedImageUrl);
          }

          let variantCompareAtPrice = 0;
          if (window.meta?.product?.variants) {
            const matching = window.meta.product.variants.find(v => String(v.id) === String(targetVariantId));
            if (matching && matching.compare_at_price) {
              variantCompareAtPrice = matching.compare_at_price / 100;
            }
          }
          if (variantCompareAtPrice === 0) {
            const analyticsVariants = window.ShopifyAnalytics?.meta?.product?.variants;
            if (analyticsVariants) {
              const matching = analyticsVariants.find(v => String(v.id) === String(targetVariantId));
              if (matching && matching.compare_at_price) {
                variantCompareAtPrice = matching.compare_at_price / 100;
              }
            }
          }

          const applyDiscountToExtras = config.applyDiscountToExtras || false;
          let currentBase = currentBasePrice;
          let currentExtras = priceAdjustmentTotal + ruleExtraSum;
          let normalTotal = currentBase + currentExtras;
          let compareAtPrice = variantCompareAtPrice > 0 ? variantCompareAtPrice + currentExtras : normalTotal;

          AureaLog.info(`Subtotal Breakdown: Base=${currentBase}, Extras=${currentExtras}, Total=${normalTotal}, CompareAt=${compareAtPrice}`);

          if (matchedPricingRuleDiscount) {
            const oldPrice = currentBase + currentExtras;
            if (applyDiscountToExtras) {
              if (matchedPricingRuleDiscount.type === "percentage") {
                const discTotal = normalTotal * (1 - matchedPricingRuleDiscount.value / 100);
                currentBase = discTotal - currentExtras;
              } else if (matchedPricingRuleDiscount.type === "fixed") {
                const discTotal = normalTotal - matchedPricingRuleDiscount.value;
                currentBase = discTotal - currentExtras;
              }
            } else {
              if (matchedPricingRuleDiscount.type === "percentage") {
                currentBase = currentBase * (1 - matchedPricingRuleDiscount.value / 100);
              } else if (matchedPricingRuleDiscount.type === "fixed") {
                currentBase = currentBase - matchedPricingRuleDiscount.value;
              }
            }
            AureaLog.info(`Applied Pricing Rule Discount. Price updated from ${oldPrice} to ${currentBase + currentExtras}`);
          }

          const discountRules = config.discountRules || [];
          const now = new Date();
          for (const rule of discountRules) {
            if (rule.startDate && new Date(rule.startDate) > now) continue;
            if (rule.endDate && new Date(rule.endDate) < now) continue;
            const oldPrice = currentBase + currentExtras;
            
            if (applyDiscountToExtras) {
              const total = currentBase + currentExtras;
              let discTotal = total;
              if (rule.type === "percentage") discTotal = total * (1 - rule.value / 100);
              else if (rule.type === "fixed") discTotal = total - rule.value;
              currentBase = discTotal - currentExtras;
            } else {
              if (rule.type === "percentage") currentBase = currentBase * (1 - rule.value / 100);
              else if (rule.type === "fixed") currentBase = currentBase - rule.value;
            }
            AureaLog.info(`Applied Global Discount Rule: ${rule.type} (${rule.value}). Price updated from ${oldPrice} to ${currentBase + currentExtras}`);
          }
          let rawPrice = Math.max(0, currentBase + currentExtras);
          
          const finalPrice = rawPrice;
          const finalCompareAt = finalPrice < compareAtPrice ? compareAtPrice : null;
          AureaLog.info(`=== END LOCAL PRICE CALCULATION === Final Price: ${finalPrice}, Compare-At: ${finalCompareAt}`);
          updatePriceUI(finalPrice, finalCompareAt);

          // Card Potential Selection Pricing calculations & display
          const getChoiceQuantity = (label) => {
            const match = label.match(/\d+/);
            return match ? parseInt(match[0], 10) : 1;
          };

          const calculatePotentialPrice = (targetFieldId, targetChoiceLabel, targetChoicePriceAdjustment) => {
            let tempBasePrice = robustBasePrice;
            let tempRuleExtraSum = 0;
            let tempPriceAdjustmentTotal = 0;

            const tempSelections = selections.filter((s) => s.fieldId !== targetFieldId);
            tempSelections.push({ fieldId: targetFieldId, value: targetChoiceLabel });

            // 1. Evaluate pricing rules
            for (const rule of pricingRules) {
              if (!rule.conditions || rule.conditions.length === 0) continue;
              const isMatch = rule.conditions.every((c) =>
                tempSelections.some((s) => {
                  const fieldEl = fieldElements.get(s.fieldId);
                  if (!fieldEl || fieldEl.style.display === "none") return false;
                  if (s.fieldId !== c.fieldId) return false;
                  const sVal = String(s.value).toLowerCase().trim();
                  const cVal = String(c.value).toLowerCase().trim();
                  if (sVal === cVal) return true;
                  if (s.choiceId && c.value && String(s.choiceId) === String(c.value)) return true;
                  return false;
                })
              );

              if (isMatch) {
                if (rule.action === "set_base") {
                  tempBasePrice = parseFloat(rule.value || 0);
                } else if (rule.action === "add") {
                  tempRuleExtraSum += parseFloat(rule.value || 0);
                } else {
                  tempBasePrice = parseFloat(rule.value || 0);
                }
              }
            }

            // 2. Evaluate individual choice price adjustments
            fields.forEach((f) => {
              const fieldEl = fieldElements.get(f.id);
              if (fieldEl && fieldEl.style.display !== "none") {
                if (f.id === targetFieldId) {
                  tempPriceAdjustmentTotal += parseFloat(targetChoicePriceAdjustment || 0);
                } else {
                  const sel = tempSelections.find((s) => s.fieldId === f.id);
                  if (sel) {
                    const choice = f.choices?.find((c) => 
                      String(c.label).trim().toLowerCase() === String(sel.value).trim().toLowerCase()
                    );
                    if (choice && choice.priceAdjustment) {
                      tempPriceAdjustmentTotal += parseFloat(choice.priceAdjustment);
                    }
                  }
                }
              }
            });

            let tempBase = tempBasePrice;
            let tempExtras = tempPriceAdjustmentTotal + tempRuleExtraSum;
            let tempNormalTotal = tempBase + tempExtras;
            let tempCompareAt = tempNormalTotal;

            // 3. Evaluate pricing rules discounts
            let tempMatchedDiscount = null;
            for (const rule of pricingRules) {
              if (!rule.conditions || rule.conditions.length === 0) continue;
              const isMatch = rule.conditions.every((c) =>
                tempSelections.some((s) => {
                  const fieldEl = fieldElements.get(s.fieldId);
                  if (!fieldEl || fieldEl.style.display === "none") return false;
                  if (s.fieldId !== c.fieldId) return false;
                  const sVal = String(s.value).toLowerCase().trim();
                  const cVal = String(c.value).toLowerCase().trim();
                  if (sVal === cVal) return true;
                  if (s.choiceId && c.value && String(s.choiceId) === String(c.value)) return true;
                  return false;
                })
              );
              if (isMatch && rule.discountValue && rule.discountType) {
                tempMatchedDiscount = { type: rule.discountType, value: rule.discountValue };
              }
            }

            if (tempMatchedDiscount) {
              if (applyDiscountToExtras) {
                if (tempMatchedDiscount.type === "percentage") {
                  tempBase = (tempNormalTotal * (1 - tempMatchedDiscount.value / 100)) - tempExtras;
                } else if (tempMatchedDiscount.type === "fixed") {
                  tempBase = (tempNormalTotal - tempMatchedDiscount.value) - tempExtras;
                }
              } else {
                if (tempMatchedDiscount.type === "percentage") {
                  tempBase = tempBase * (1 - tempMatchedDiscount.value / 100);
                } else if (tempMatchedDiscount.type === "fixed") {
                  tempBase = tempBase - tempMatchedDiscount.value;
                }
              }
            }

            // 4. Evaluate global discounts
            for (const rule of discountRules) {
              if (rule.startDate && new Date(rule.startDate) > now) continue;
              if (rule.endDate && new Date(rule.endDate) < now) continue;
              if (applyDiscountToExtras) {
                const total = tempBase + tempExtras;
                let discTotal = total;
                if (rule.type === "percentage") discTotal = total * (1 - rule.value / 100);
                else if (rule.type === "fixed") discTotal = total - rule.value;
                tempBase = discTotal - tempExtras;
              } else {
                if (rule.type === "percentage") tempBase = tempBase * (1 - rule.value / 100);
                else if (rule.type === "fixed") tempBase = tempBase - rule.value;
              }
            }

            const finalTempPrice = Math.max(0, tempBase + tempExtras);
            return {
              price: finalTempPrice,
              compareAtPrice: finalTempPrice < tempCompareAt ? tempCompareAt : null
            };
          };

          fields.forEach((f) => {
            if (f.type === "cards") {
              const fieldEl = fieldElements.get(f.id);
              if (fieldEl && fieldEl.style.display !== "none") {
                (f.choices || []).forEach((choice) => {
                  const card = fieldEl.querySelector(`.aurea-card-option[data-choice-label="${choice.label}"]`);
                  if (card) {
                    const potential = calculatePotentialPrice(f.id, choice.label, choice.priceAdjustment);
                    const pricesContainer = card.querySelector(".aurea-card-prices");
                    if (pricesContainer) {
                      pricesContainer.innerHTML = "";
                      
                      const priceRow = document.createElement("div");
                      priceRow.className = "aurea-card-price-row";

                      if (f.showPriceInVariants !== false) {
                        const curPriceSpan = document.createElement("span");
                        curPriceSpan.className = "aurea-card-current-price";
                        curPriceSpan.innerText = AureaUtils.formatAureaMoney(potential.price);
                        priceRow.appendChild(curPriceSpan);

                        if (potential.compareAtPrice) {
                          const compPriceSpan = document.createElement("span");
                          compPriceSpan.className = "aurea-card-compare-price";
                          compPriceSpan.innerText = AureaUtils.formatAureaMoney(potential.compareAtPrice);
                          priceRow.appendChild(compPriceSpan);
                        }
                      }
                      pricesContainer.appendChild(priceRow);

                      if (f.showUnitPriceInVariants === true) {
                        const qty = getChoiceQuantity(choice.label);
                        const unitPrice = potential.price / qty;
                        const unitPriceDiv = document.createElement("div");
                        unitPriceDiv.className = "aurea-card-unit-price";
                        unitPriceDiv.innerText = `${AureaUtils.formatAureaMoney(unitPrice)} / un.`;
                        pricesContainer.appendChild(unitPriceDiv);
                      }

                      if (f.showDiscountInVariants === true && potential.compareAtPrice && potential.compareAtPrice > potential.price) {
                        const discountPercent = Math.round(((potential.compareAtPrice - potential.price) / potential.compareAtPrice) * 100);
                        if (discountPercent > 0) {
                          const badge = document.createElement("div");
                          badge.className = "aurea-card-discount-badge";
                          badge.innerText = `Ahorra ${discountPercent}%`;
                          pricesContainer.appendChild(badge);
                        }
                      }
                    }
                  }
                });
              }
            }
          });
        } catch (e) {
          AureaLog.error("[Auréa Bridge] Sync Price Calc Error", e);
        }

        const submitBtn = AureaUtils.getSubmitBtnEl(form);
        if (submitBtn) {
          if (!isAvailable) {
            submitBtn.disabled = true;
            if (!submitBtn.dataset.originalText) submitBtn.dataset.originalText = submitBtn.innerText;
            submitBtn.innerText = "No Disponible";
          } else {
            submitBtn.disabled = false;
            if (submitBtn.dataset.originalText) {
              submitBtn.innerText = submitBtn.dataset.originalText;
              delete submitBtn.dataset.originalText;
            }
          }
        }
      };

      fields.forEach((field) => {
        let fieldDiv = null;
        if (isNative) {
          fieldDiv = container.querySelector(`[data-field-id="${field.id}"]`);
        }

        const isFieldRequired = field.required === true || String(field.required) === "true";
        const propName = `properties[${field.label}]`;

        if (isNative && fieldDiv) {
          fieldElements.set(field.id, fieldDiv);
          
          if (field.type === "dropdown" || field.type === "select") {
            const select = fieldDiv.querySelector("select");
            if (select) {
              select.setAttribute("form", formId);
              fieldInputs.set(field.id, select);
              select.addEventListener("change", updateVisibility);
            }
          } else if (field.type === "radio") {
            const firstRadio = fieldDiv.querySelector('input[type="radio"]');
            if (firstRadio) {
              fieldInputs.set(field.id, firstRadio);
            }
            const radios = fieldDiv.querySelectorAll('input[type="radio"]');
            radios.forEach((r) => {
              r.setAttribute("form", formId);
              r.addEventListener("change", updateVisibility);
            });
          } else if (field.type === "checkbox_group") {
            const hiddenInput = fieldDiv.querySelector('input[type="hidden"]');
            if (hiddenInput) {
              hiddenInput.setAttribute("form", formId);
              fieldInputs.set(field.id, hiddenInput);
            }
            const checkboxes = fieldDiv.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((cb) => {
              cb.addEventListener("change", () => {
                const checked = Array.from(checkboxes).filter((c) => c.checked).map((c) => c.value);
                if (hiddenInput) {
                  hiddenInput.value = checked.join(", ");
                }
                updateVisibility();
              });
            });
          } else if (field.type === "checkbox") {
            const checkbox = fieldDiv.querySelector('input[type="checkbox"]');
            if (checkbox) {
              checkbox.setAttribute("form", formId);
              fieldInputs.set(field.id, checkbox);
              checkbox.addEventListener("change", updateVisibility);
            }
          } else if (field.type === "cards") {
            const firstRadio = fieldDiv.querySelector('input[type="radio"]');
            if (firstRadio) {
              fieldInputs.set(field.id, firstRadio);
            }
            const cards = fieldDiv.querySelectorAll(".aurea-card-option");
            cards.forEach((card) => {
              const radio = card.querySelector('input[type="radio"]');
              if (radio) {
                radio.setAttribute("form", formId);
                radio.addEventListener("change", () => {
                  cards.forEach((c) => c.classList.remove("is-selected"));
                  card.classList.add("is-selected");
                  updateVisibility();
                });
              }
              card.onclick = (e) => {
                e.preventDefault();
                if (radio && !radio.checked) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event("change"));
                }
              };
            });
          } else if (field.type === "file") {
            const fileInput = fieldDiv.querySelector('input[type="file"]');
            const uploadBtn = fieldDiv.querySelector(".aurea-file-upload-btn");
            const replaceBtn = fieldDiv.querySelector(".aurea-file-replace-btn");
            const hiddenInput = fieldDiv.querySelector('input[type="hidden"]');

            if (fileInput) {
              fileInput.setAttribute("form", formId);
              fieldInputs.set(field.id, fileInput);
              if (hiddenInput) hiddenInput.setAttribute("form", formId);

              if (uploadBtn) {
                uploadBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };
              }
              if (replaceBtn) {
                replaceBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };
              }
              fileInput.onchange = (e) => {
                if (e.target.files.length) {
                  if (uploadBtn) uploadBtn.style.display = "none";
                  AureaUploadManager.handleFileUpload(e.target.files[0], field.id, propName);
                }
              };
            }
          } else if (field.type === "file_group") {
            const inputsToRegister = [];
            (field.choices || []).forEach((choice) => {
              const rPropName = `properties[${field.label} - ${choice.label}]`;
              const rowWrapper = fieldDiv.querySelector(`.aurea-file-group-row[data-choice-label="${choice.label}"]`);
              if (rowWrapper) {
                const fileInput = rowWrapper.querySelector('input[type="file"]');
                const uploadBtn = rowWrapper.querySelector(".aurea-file-upload-btn");
                const replaceBtn = rowWrapper.querySelector(".aurea-file-replace-btn");
                const hiddenInput = rowWrapper.querySelector('input[type="hidden"]');

                if (fileInput) {
                  fileInput.setAttribute("form", formId);
                  inputsToRegister.push(fileInput);
                  if (hiddenInput) hiddenInput.setAttribute("form", formId);

                  if (uploadBtn) {
                    uploadBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };
                  }
                  if (replaceBtn) {
                    replaceBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };
                  }
                  fileInput.onchange = (e) => {
                    if (e.target.files.length) {
                      if (uploadBtn) uploadBtn.style.display = "none";
                      AureaUploadManager.handleFileUpload(e.target.files[0], field.id, rPropName);
                    }
                  };
                }
              }
            });
            if (inputsToRegister.length > 0) fieldInputs.set(field.id, inputsToRegister[0]);
          } else if (field.type === "textarea") {
            const textarea = fieldDiv.querySelector("textarea");
            if (textarea) {
              textarea.setAttribute("form", formId);
              fieldInputs.set(field.id, textarea);
              textarea.addEventListener("input", updateVisibility);
            }
          } else {
            const input = fieldDiv.querySelector("input");
            if (input) {
              input.setAttribute("form", formId);
              fieldInputs.set(field.id, input);
              input.addEventListener("input", updateVisibility);
            }
          }
          return;
        }

        fieldDiv = document.createElement("div");
        fieldDiv.setAttribute("data-field-id", field.id);
        fieldDiv.className = "aurea-field";
        fieldDiv.dataset.required = field.required === true || String(field.required) === "true" ? "true" : "false";

        fieldElements.set(field.id, fieldDiv);
        const label = document.createElement("label");
        label.className = "aurea-label";
        label.innerText = field.label + (isFieldRequired ? " *" : "");
        if (field.type !== "checkbox") fieldDiv.appendChild(label);

        if (field.type === "dropdown") {
          const select = document.createElement("select");
          select.className = "aurea-input custom-option-select";
          select.name = propName;
          select.required = isFieldRequired;
          select.setAttribute("form", formId);

          if (isFieldRequired) {
            const defaultOpt = document.createElement("option");
            defaultOpt.value = "";
            defaultOpt.innerText = "Selecciona una opción...";
            defaultOpt.disabled = true;
            defaultOpt.selected = !(field.choices || []).some((c) => c.isDefault === true || String(c.isDefault) === "true");
            select.appendChild(defaultOpt);
          }

          (field.choices || []).forEach((choice) => {
            const opt = document.createElement("option");
            opt.value = choice.label;
            opt.innerText = choice.label + (choice.priceAdjustment && !hideExtra ? ` (+${AureaUtils.formatAureaMoney(parseFloat(choice.priceAdjustment))})` : "");
            if (choice.isDefault === true || String(choice.isDefault) === "true") opt.selected = true;
            select.appendChild(opt);
          });
          fieldInputs.set(field.id, select);
          select.addEventListener("change", updateVisibility);
          fieldDiv.appendChild(select);
        } else if (field.type === "radio") {
          const radioGroup = document.createElement("div");
          radioGroup.className = "aurea-choice-group";

          (field.choices || []).forEach((choice, idx) => {
            const wrapper = document.createElement("label");
            wrapper.className = "aurea-choice-wrapper";
            wrapper.setAttribute("data-choice-label", choice.label);

            const radio = document.createElement("input");
            radio.type = "radio";
            radio.name = propName;
            radio.value = choice.label;
            radio.required = isFieldRequired;
            if (choice.isDefault === true || String(choice.isDefault) === "true") radio.checked = true;
            radio.setAttribute("form", formId);
            radio.addEventListener("change", updateVisibility);
            if (idx === 0) fieldInputs.set(field.id, radio);

            wrapper.appendChild(radio);
            wrapper.appendChild(document.createTextNode(choice.label + (choice.priceAdjustment && !hideExtra ? ` (+${AureaUtils.formatAureaMoney(parseFloat(choice.priceAdjustment))})` : "")));
            radioGroup.appendChild(wrapper);
          });
          fieldDiv.appendChild(radioGroup);
        } else if (field.type === "cards") {
          const cardsGroup = document.createElement("div");
          if (field.cardsLayout === "full") {
            cardsGroup.className = "aurea-cards-group aurea-cards-layout-full";
          } else {
            cardsGroup.className = "aurea-cards-group aurea-cards-layout-grid";
          }

          (field.choices || []).forEach((choice, idx) => {
            const card = document.createElement("div");
            card.className = "aurea-card-option";
            card.setAttribute("data-choice-label", choice.label);

            const radio = document.createElement("input");
            radio.type = "radio";
            radio.name = propName;
            radio.value = choice.label;
            radio.required = isFieldRequired;
            radio.style.display = "none";
            if (choice.isDefault === true || String(choice.isDefault) === "true") {
              radio.checked = true;
              card.classList.add("is-selected");
            }
            radio.setAttribute("form", formId);
            radio.addEventListener("change", () => {
              cardsGroup.querySelectorAll(".aurea-card-option").forEach((c) => {
                c.classList.remove("is-selected");
              });
              card.classList.add("is-selected");
              updateVisibility();
            });
            if (idx === 0) fieldInputs.set(field.id, radio);

            card.appendChild(radio);

            card.onclick = (e) => {
              e.preventDefault();
              if (!radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event("change"));
              }
            };

            const cardLabel = document.createElement("div");
            cardLabel.className = "aurea-card-label";
            cardLabel.innerText = choice.label;
            card.appendChild(cardLabel);

            const pricesContainer = document.createElement("div");
            pricesContainer.className = "aurea-card-prices";
            card.appendChild(pricesContainer);

            cardsGroup.appendChild(card);
          });
          fieldDiv.appendChild(cardsGroup);
        } else if (field.type === "checkbox_group") {
          const checkGroup = document.createElement("div");
          checkGroup.className = "aurea-choice-group";

          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = propName;
          hiddenInput.setAttribute("form", formId);
          fieldInputs.set(field.id, hiddenInput);
          checkGroup.appendChild(hiddenInput);

          const updateHidden = () => {
            const checked = Array.from(checkGroup.querySelectorAll('input[type="checkbox"]:checked')).map((cb) => cb.value);
            hiddenInput.value = checked.join(", ");
            updateVisibility();
          };

          (field.choices || []).forEach((choice) => {
            const wrapper = document.createElement("label");
            wrapper.className = "aurea-choice-wrapper";
            wrapper.setAttribute("data-choice-label", choice.label);

            const cb = document.createElement("input");
            cb.type = "checkbox";
            cb.value = choice.label;
            cb.name = "ignore_" + Math.random().toString(36).substring(2);
            if (choice.isDefault === true || String(choice.isDefault) === "true") cb.checked = true;
            cb.addEventListener("change", updateHidden);
            wrapper.appendChild(cb);
            wrapper.appendChild(document.createTextNode(choice.label + (choice.priceAdjustment && !hideExtra ? ` (+${AureaUtils.formatAureaMoney(parseFloat(choice.priceAdjustment))})` : "")));
            checkGroup.appendChild(wrapper);
          });

          updateHidden();
          fieldDiv.appendChild(checkGroup);
        } else if (field.type === "checkbox") {
          const choice = field.choices && field.choices.length > 0 ? field.choices[0] : null;

          const wrapper = document.createElement("label");
          wrapper.className = "aurea-choice-wrapper";

          const checkbox = document.createElement("input");
          checkbox.type = "checkbox";
          checkbox.name = propName;
          checkbox.value = choice && choice.label ? choice.label : "true";
          checkbox.required = isFieldRequired;
          if (choice && (choice.isDefault === true || String(choice.isDefault) === "true")) checkbox.checked = true;
          checkbox.setAttribute("form", formId);
          checkbox.addEventListener("change", updateVisibility);
          fieldInputs.set(field.id, checkbox);

          const textLabel = choice && choice.label ? choice.label : field.label || "Marcar";
          const priceExtra = choice && choice.priceAdjustment && !hideExtra ? ` (+${AureaUtils.formatAureaMoney(parseFloat(choice.priceAdjustment))})` : "";

          wrapper.appendChild(checkbox);
          wrapper.appendChild(document.createTextNode(textLabel + priceExtra));
          fieldDiv.appendChild(wrapper);
        } else if (field.type === "file") {
          const uploadContainer = document.createElement("div");
          uploadContainer.id = `upload-container-${field.id}`;
          uploadContainer.className = "aurea-file-upload-wrapper";
          uploadContainer.innerHTML = `
              <button type="button" class="aurea-file-upload-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                  <span>Seleccionar archivo</span>
              </button>
              <div class="aurea-file-upload-progress">
                  <div class="aurea-file-upload-bar"></div>
              </div>
              <div class="aurea-file-preview" style="display: none; align-items: center; justify-content: space-between;">
                  <div style="display: flex; align-items: center; gap: 12px; min-width: 0;">
                      <img src="" alt="Vista previa">
                      <div class="aurea-file-preview-info">
                          <div class="aurea-file-preview-name"></div>
                          <div class="aurea-file-status-tag aurea-status-uploading">Subiendo...</div>
                      </div>
                  </div>
                  <button type="button" class="aurea-file-replace-btn" style="flex-shrink: 0; padding: 6px 12px; font-size: 12px; background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; cursor: pointer; color: #334155; font-weight: 500;">Cambiar</button>
              </div>
              <input type="file" name="${propName}" id="input-${field.id}" style="display: none;" ${isFieldRequired ? "required" : ""}>
          `;

          const fileInput = uploadContainer.querySelector('input[type="file"]');
          const uploadBtn = uploadContainer.querySelector(".aurea-file-upload-btn");
          const replaceBtn = uploadContainer.querySelector(".aurea-file-replace-btn");

          uploadBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };
          replaceBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };

          fileInput.onchange = (e) => {
            if (e.target.files.length) {
              uploadBtn.style.display = "none";
              AureaUploadManager.handleFileUpload(e.target.files[0], field.id, propName);
            }
          };

          fieldInputs.set(field.id, fileInput);
          fieldDiv.appendChild(uploadContainer);
        } else if (field.type === "file_group") {
          const fileGroupDiv = document.createElement("div");
          fileGroupDiv.className = "aurea-file-group-container";

          const inputsToRegister = [];

          (field.choices || []).forEach((choice) => {
            const rPropName = `properties[${field.label} - ${choice.label}]`;

            const fileRow = document.createElement("div");
            fileRow.className = "aurea-file-group-row";
            fileRow.setAttribute("data-choice-label", choice.label);

            const rowLabel = document.createElement("div");
            rowLabel.className = "aurea-file-row-label";
            rowLabel.innerText = choice.label + (choice.priceAdjustment && !hideExtra ? ` (+${AureaUtils.formatAureaMoney(parseFloat(choice.priceAdjustment))})` : "");
            fileRow.appendChild(rowLabel);

            const uploadContainer = document.createElement("div");
            uploadContainer.id = `upload-container-${field.id}-${choice.label.toLowerCase().replace(/\s+/g, "-")}`;
            uploadContainer.className = "aurea-file-upload-wrapper";
            uploadContainer.innerHTML = `
               <button type="button" class="aurea-file-upload-btn" style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px;">
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 14px; height: 14px;"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                   <span>Subir ${choice.label}</span>
               </button>
               <div class="aurea-file-upload-progress" style="display: none; height: 4px; background: #e2e8f0; border-radius: 2px; overflow: hidden; margin-top: 4px;">
                   <div class="aurea-file-upload-bar" style="width: 0%; height: 100%; background: #4f46e5; border-radius: 2px; transition: width 0.2s;"></div>
               </div>
               <div class="aurea-file-preview" style="display: none; align-items: center; justify-content: space-between;">
                   <div style="display: flex; align-items: center; gap: 12px; min-width: 0;">
                       <img src="" alt="Vista previa" style="width: 32px; height: 32px; object-fit: cover; border-radius: 4px;">
                       <div class="aurea-file-preview-info">
                           <div class="aurea-file-preview-name" style="font-size: 13px; font-weight: 500;"></div>
                           <div class="aurea-file-status-tag aurea-status-uploading">Subiendo...</div>
                       </div>
                   </div>
                   <button type="button" class="aurea-file-replace-btn" style="flex-shrink: 0; padding: 6px 12px; font-size: 11px; background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; cursor: pointer; color: #334155; font-weight: 500;">Cambiar</button>
               </div>
               <input type="file" name="${rPropName}" id="input-${field.id}-${choice.label.toLowerCase().replace(/\s+/g, "-")}" style="display: none;" ${isFieldRequired ? "required" : ""}>
            `;

            const fileInput = uploadContainer.querySelector('input[type="file"]');
            const uploadBtn = uploadContainer.querySelector(".aurea-file-upload-btn");
            const replaceBtn = uploadContainer.querySelector(".aurea-file-replace-btn");

            uploadBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };
            replaceBtn.onclick = (e) => { e.preventDefault(); fileInput.click(); };

            fileInput.onchange = (e) => {
              if (e.target.files.length) {
                uploadBtn.style.display = "none";
                AureaUploadManager.handleFileUpload(e.target.files[0], field.id, rPropName);
              }
            };

            fileRow.appendChild(uploadContainer);
            fileGroupDiv.appendChild(fileRow);
            inputsToRegister.push(fileInput);
          });

          if (inputsToRegister.length > 0) fieldInputs.set(field.id, inputsToRegister[0]);
          fieldDiv.appendChild(fileGroupDiv);
        } else if (field.type === "textarea") {
          const input = document.createElement("textarea");
          input.className = "aurea-input aurea-input-textarea";
          input.name = propName;
          input.required = isFieldRequired;
          input.setAttribute("form", formId);
          input.addEventListener("input", updateVisibility);
          fieldInputs.set(field.id, input);
          fieldDiv.appendChild(input);
        } else {
          const input = document.createElement("input");
          input.className = "aurea-input";
          input.type = "text";
          input.name = propName;
          input.required = isFieldRequired;
          input.setAttribute("form", formId);
          input.addEventListener("input", updateVisibility);
          fieldInputs.set(field.id, input);
          fieldDiv.appendChild(input);
        }

        container.appendChild(fieldDiv);
      });

      const insertContainer = () => {
        // SI ES NATIVO (Custom Liquid), NO LO MUEVAS. Déjalo donde lo puso el merchant.
        if (isNative) return; 
        
        // Si no es nativo, lo inyecta antes del botón de comprar (como hacía antes)
        const sBtn = AureaUtils.getSubmitBtnEl(form);
        const btnsC = sBtn ? sBtn.closest(".product-form__buttons") || sBtn.parentElement : null;
        if (btnsC && btnsC.parentElement === form) {
          form.insertBefore(container, btnsC);
        } else {
          form.appendChild(container);
        }
      };

      insertContainer();
      updateVisibility();
      container.setAttribute("data-aurea-initialized", "true");

      if (typeof window._aureaUnhidePrices === "function") window._aureaUnhidePrices();

      // --- HACK PARA EL EDITOR DE SHOPIFY ---
      // Si estamos dentro del Editor de Temas, forzamos un evento de redimensión
      // para que Shopify recalcule el recuadro azul del bloque Custom Liquid.
      if (window.Shopify && window.Shopify.designMode) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 300);
      }

      const runValidation = () => {
        let isValid = true;
        let firstInvalid = null;

        const currentFields = container.querySelectorAll(".aurea-field");
        currentFields.forEach((f) => {
          if (f.style.display === "none") return;

          const isRequired = f.dataset.required === "true";
          if (!isRequired) return;

          const radios = f.querySelectorAll('input[type="radio"]');
          const checkboxes = f.querySelectorAll('input[type="checkbox"]');
          const selects = f.querySelectorAll("select");
          const texts = f.querySelectorAll('input[type="text"], textarea');
          const fileInputs = f.querySelectorAll('input[type="file"]');

          let fieldHasValue = false;
          if (radios.length > 0) {
            fieldHasValue = Array.from(radios).some((r) => r.checked);
          } else if (checkboxes.length > 0) {
            fieldHasValue = Array.from(checkboxes).some((c) => c.checked);
          } else if (selects.length > 0) {
            fieldHasValue = selects[0].value && selects[0].value.trim() !== "";
          } else if (texts.length > 0) {
            fieldHasValue = texts[0].value && texts[0].value.trim() !== "";
          } else if (fileInputs.length > 0) {
            const visibleFileInputs = Array.from(fileInputs).filter((inp) => {
              const row = inp.closest(".aurea-file-group-row");
              return !row || row.style.display !== "none";
            });
            fieldHasValue = visibleFileInputs.length > 0
              ? visibleFileInputs.every((fInp) => fInp.files && fInp.files.length > 0)
              : true;
          }

          if (!fieldHasValue) {
            isValid = false;
            f.style.border = "1px solid #d93025";
            f.style.padding = "5px";
            f.style.borderRadius = "4px";
            setTimeout(() => {
              if (f) {
                f.style.border = "none";
                f.style.padding = "0";
              }
            }, 3000);
            if (!firstInvalid) firstInvalid = f;
          }
        });

        if (!isValid) {
          if (!document.getElementById("aurea-validation-error")) {
            const errBox = document.createElement("div");
            errBox.id = "aurea-validation-error";
            errBox.className = "aurea-error-box";
            errBox.innerText = "Por favor completa las opciones obligatorias (*).";
            container.insertBefore(errBox, container.firstChild);
          }
          if (firstInvalid) firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
          return false;
        }

        const errBox = document.getElementById("aurea-validation-error");
        if (errBox) errBox.remove();
        return true;
      };

      const _resetAllFields = () => {
        fields.forEach((f) => {
          const fieldEl = fieldElements.get(f.id);
          const input = fieldInputs.get(f.id);
          if (!input) return;
          if (f.type === "dropdown" || f.type === "radio" || f.type === "cards") {
            const defaultChoice = f.choices?.find((c) => c.isDefault);
            if (input.type === "radio") {
              const radios = container.querySelectorAll(`input[name="properties[${f.label}]"]`);
              radios.forEach((r) => { r.checked = defaultChoice ? r.value === defaultChoice.label : false; });

              if (f.type === "cards" && fieldEl) {
                fieldEl.querySelectorAll(".aurea-card-option").forEach((card) => {
                  const cardInput = card.querySelector("input");
                  if (cardInput && cardInput.checked) {
                    card.classList.add("is-selected");
                  } else {
                    card.classList.remove("is-selected");
                  }
                });
              }
            } else {
              input.value = defaultChoice ? defaultChoice.label : "";
            }
          } else if (f.type === "checkbox_group") {
            const checkboxes = input.parentElement ? input.parentElement.querySelectorAll('input[type="checkbox"]') : [];
            checkboxes.forEach((cb) => {
              const choice = f.choices?.find((c) => String(c.label) === String(cb.value));
              cb.checked = choice ? choice.isDefault === true || String(choice.isDefault) === "true" : false;
            });
            const checked = Array.from(checkboxes).filter((cb) => cb.checked).map((cb) => cb.value);
            input.value = checked.join(", ");
          } else if (input.type === "checkbox") {
            const choice = f.choices && f.choices.length > 0 ? f.choices[0] : null;
            input.checked = (choice && (choice.isDefault === true || String(choice.isDefault) === "true")) || false;
          } else if (f.type === "file" || f.type === "file_group") {
            if (fieldEl) {
              const fileInputs = fieldEl.querySelectorAll('input[type="file"]');
              fileInputs.forEach((fileInput) => {
                fileInput.value = "";
                
                const rowWrapper = fileInput.closest(".aurea-file-group-row") || fileInput.closest(".aurea-field") || fieldEl;
                
                const preview = rowWrapper.querySelector(".aurea-file-preview");
                if (preview) {
                  preview.style.display = "none";
                  const img = preview.querySelector("img");
                  if (img) img.src = "";
                  const name = preview.querySelector(".aurea-file-preview-name");
                  if (name) name.innerText = "";
                  const statusTag = preview.querySelector(".aurea-file-status-tag");
                  if (statusTag) {
                    statusTag.innerText = "";
                    statusTag.className = "aurea-file-status-tag";
                  }
                }
                
                const uploadBtn = rowWrapper.querySelector(".aurea-file-upload-btn");
                if (uploadBtn) uploadBtn.style.setProperty("display", "flex", "important");
                
                const replaceBtn = rowWrapper.querySelector(".aurea-file-replace-btn");
                if (replaceBtn) replaceBtn.style.setProperty("display", "none", "important");
                
                const progress = rowWrapper.querySelector(".aurea-file-upload-progress");
                if (progress) progress.style.display = "none";
                
                const bar = rowWrapper.querySelector(".aurea-file-upload-bar");
                if (bar) bar.style.width = "0%";
                
                const hiddenUrlInput = rowWrapper.querySelector('input[type="hidden"]');
                if (hiddenUrlInput) hiddenUrlInput.value = "";

                delete fileUploads[fileInput.name];
                activeUploads.delete(fileInput.name);
              });
            }
          } else {
            input.value = "";
          }
        });
        updateVisibility();
      };

      const handleFormInteraction = async (e) => {
        const form = e.target.closest("form") || e.target;
        AureaLog.info("=== Form submit interaction initiated ===");
        if (form._aureaSubmittedWithNewVariant) {
          AureaLog.info("Form submission already processed with new variant, allowing default submission to Shopify.");
          form._aureaSubmittedWithNewVariant = false;
          setTimeout(_resetAllFields, 1000);
          return;
        }

        const targetBtn = e.target.closest('[type="submit"], [name="add"], button.add-to-cart, .product-form__submit');
        AureaLog.info("Click/Submit targets details:", { eventType: e.type, targetBtn, eventTarget: e.target });
        if (e.type === "click" && !targetBtn) {
          AureaLog.info("Click event did not originate from a submit button, ignoring.");
          return;
        }

        AureaLog.info("Running option field validation...");
        if (!runValidation()) {
          AureaLog.error("Option validation failed. Blocking form submission.");
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          return false;
        }
        AureaLog.success("Option validation succeeded!");

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        if (window._aureaProcessing) {
          AureaLog.warn("Submission is already in progress, ignoring duplicate submit action.");
          return;
        }
        window._aureaProcessing = true;

        const shop = AureaUtils.getShop();
        let targetVariantId = "";

        const idInputs = form.querySelectorAll('[name="id"]');
        if (idInputs.length > 0) {
          for (let input of idInputs) {
            if (!input.disabled && input.value) {
              targetVariantId = input.dataset.aureaOriginalId || input.value;
              AureaLog.info(`Found targetVariantId from input[name="id"]: ${targetVariantId} (originalId dataset: ${input.dataset.aureaOriginalId})`);
              break;
            }
          }
        }

        if (!targetVariantId) {
          const urlParams = new URLSearchParams(window.location.search);
          targetVariantId = urlParams.get("variant");
          AureaLog.info(`TargetVariantId from url params: ${targetVariantId}`);
        }

        if (!targetVariantId && window.meta?.product?.variants) {
          targetVariantId = window.meta.product.variants[0].id;
          AureaLog.info(`TargetVariantId from first product variant in metadata: ${targetVariantId}`);
        }

        const btn = targetBtn || AureaUtils.getSubmitBtnEl(form);
        const originalHTML = btn ? btn.innerHTML : "";
        const originalValue = btn && btn.tagName === "INPUT" ? btn.value : "";

        if (btn) {
          btn.classList.add("loading");
          const updateBtnText = (text) => {
            if (btn.tagName === "INPUT") btn.value = text;
            else {
              const span = btn.querySelector("span") || btn;
              span.innerText = text;
            }
          };
          updateBtnText("Validando...");
          btn.disabled = true;

          const pending = Array.from(activeUploads.entries()).filter(([_, d]) => d.status === "uploading");
          if (pending.length > 0) {
            updateBtnText("Subiendo archivos...");
            AureaLog.info("Waiting for file uploads to complete...", pending);
            await new Promise((resolve, reject) => {
              const check = () => {
                const stillPending = Array.from(activeUploads.values()).some((d) => d.status === "uploading");
                if (!stillPending) resolve();
                else setTimeout(check, 500);
              };
              check();
              setTimeout(() => reject(new Error("File upload timeout")), 60000);
            });
          }
          
          const hasErrors = Array.from(activeUploads.values()).some((d) => d.status === "error");
          if (hasErrors) {
            AureaLog.warn("Upload errors detected. Blocking form submission.");
            updateBtnText(originalBtnText);
            submitBtn.disabled = false;
            alert("Hubo un error al subir algunos archivos. Por favor, vuelve a intentarlo o cambia el archivo.");
            return;
          }

          updateBtnText("Añadiendo...");
        }

        try {
          const allSelectedValues = {};
          const selections = [];

          fields.forEach((f) => {
            const fieldEl = fieldElements.get(f.id);
            if (fieldEl && fieldEl.style.display !== "none") {
              const input = fieldInputs.get(f.id);
              if (input) {
                let val = "";
                if (input.type === "radio") {
                  const checked = container.querySelector(`[name="properties[${f.label}]"]:checked`);
                  val = checked ? checked.value : "";
                } else if (input.type === "checkbox") {
                  val = input.checked ? input.value : "";
                } else {
                  val = input.value;
                }

                if (val) {
                  if (f.type === "checkbox_group") {
                    const vals = val.split(",").map((v) => v.trim()).filter(Boolean);
                    vals.forEach((v) => {
                      const choice = f.choices?.find((c) => String(c.label) === String(v));
                      selections.push({ fieldId: f.id, value: v, choiceId: choice ? choice.id : null });
                    });
                  } else {
                    const choice = f.choices?.find((c) => String(c.label) === String(val));
                    selections.push({ fieldId: f.id, value: val, choiceId: choice ? choice.id : null });
                  }
                }
              }
            }
          });

          const script = document.querySelector('script[src*="bridge.js"]');
          const shopArg = script ? new URLSearchParams(script.src.split("?")[1]).get("shop") : "";
          const shopFinal = shopArg || AureaUtils.getShop();

          let shopifyBasePrice = 0;
          if (config && config.pricingRules) {
            for (const rule of config.pricingRules) {
                if (rule.action === 'set_base') {
                    shopifyBasePrice = parseFloat(rule.value || 0);
                }
            }
          }

          let workerUrl = window._aureaWorkerUrl;
          if (workerUrl && !workerUrl.startsWith("http")) workerUrl = "https://" + workerUrl;

          const priceCalcUrl = workerUrl
            ? `${workerUrl}/api/shopify/calculate-price`
            : `${window._aureaBaseUrl}/api/shopify/calculate-price`;

          const payload = { productId, selections, shopifyBasePrice, variantId: targetVariantId, shop: shopFinal };
          AureaLog.info(`Sending POST request to Cloudflare Worker calculated price API: ${priceCalcUrl}`, payload);

          const res = await fetch(priceCalcUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });

          let calcData;
          if (!res.ok) {
            try {
              const errData = await res.json();
              if (errData.error) {
                alert(`Error: ${errData.error}`);
              }
            } catch (e) {}
            throw new Error(`Worker calculation response error with status: ${res.status}`);
          }

          calcData = await res.json();
          AureaLog.success("Received pricing/variant calculation data from Cloudflare Worker:", calcData);

          let finalVariantId = calcData && calcData.variantId ? calcData.variantId : targetVariantId;
          AureaLog.info(`Setting window._aureaLatestVariantId to: ${finalVariantId} (was: ${window._aureaLatestVariantId})`);
          window._aureaLatestVariantId = finalVariantId;

          const fileInputs = form.querySelectorAll('input[type="file"]');
          const fileUrls = {};

          fileInputs.forEach((input) => {
            if (input.closest(".aurea-field") && fileUploads[input.name]) {
              fileUrls[input.name] = fileUploads[input.name];
            }
          });

          const oldInjected = form.querySelectorAll("input.aurea-injected-prop");
          AureaLog.info(`Removing ${oldInjected.length} stale injected property inputs.`);
          oldInjected.forEach((el) => el.remove());

          fields.forEach((f) => {
            const fieldEl = fieldElements.get(f.id);
            if (fieldEl && fieldEl.style.display !== "none") {
              const input = fieldInputs.get(f.id);
              if (input) {
                let val = "";
                if (input.type === "radio") {
                  const checked = container.querySelector(`[name="properties[${f.label}]"]:checked`);
                  val = checked ? checked.value : "";
                } else if (input.type === "checkbox") {
                  val = input.checked ? input.value : "";
                } else if (f.type === "checkbox_group") {
                  const checkedCbs = fieldEl.querySelectorAll('input[type="checkbox"]:checked');
                  val = Array.from(checkedCbs).map((cb) => cb.value).join(", ");
                } else {
                  val = input.value;
                }

                if (val) {
                  if (f.type === "file" || f.type === "file_group") return;

                  const hiddenProp = document.createElement("input");
                  hiddenProp.type = "hidden";
                  hiddenProp.className = "aurea-injected-prop";
                  hiddenProp.name = `properties[${f.label}]`;
                  hiddenProp.value = val;
                  form.appendChild(hiddenProp);
                  AureaLog.info(`Injected line item property input: ${hiddenProp.name} = "${hiddenProp.value}"`);

                  setTimeout(() => { if (hiddenProp) hiddenProp.remove(); }, 1500);
                }
              }
            }
          });

          if (idInputs.length > 0) {
            idInputs.forEach((input, idx) => {
              input.dataset.aureaOriginalId = input.value;
              input.value = finalVariantId;
              AureaLog.info(`Overriding ID input [${idx}] from ${input.dataset.aureaOriginalId} to ${finalVariantId}`);

              setTimeout(() => {
                if (input.dataset.aureaOriginalId) {
                  AureaLog.info(`Restoring ID input [${idx}] back to original: ${input.dataset.aureaOriginalId}`);
                  input.value = input.dataset.aureaOriginalId;
                  input.dataset.aureaOriginalId = "";
                }
              }, 500);
            });
          } else {
            const hiddenId = document.createElement("input");
            hiddenId.type = "hidden";
            hiddenId.name = "id";
            hiddenId.value = finalVariantId;
            form.appendChild(hiddenId);
            AureaLog.info(`No existing [name="id"] inputs found. Appended temporary input[type="hidden"][name="id"] with value: ${finalVariantId}`);

            setTimeout(() => { if (hiddenId) hiddenId.remove(); }, 500);
          }

          if (globalPriceInput) {
            AureaLog.info("Temporarily disabling globalPriceInput during submission.");
            globalPriceInput.disabled = true;
          }

          fileInputs.forEach((input) => {
            if (input.name && fileUrls[input.name]) {
              const urlVal = fileUrls[input.name];
              let invisibleStr = "\u200D\u200D\u200D";
              try {
                const utf8Bytes = new TextEncoder().encode(urlVal);
                for (let i = 0; i < utf8Bytes.length; i++) {
                  const bin = utf8Bytes[i].toString(2).padStart(8, "0");
                  for (let bit of bin) {
                    invisibleStr += bit === "1" ? "\u200C" : "\u200B";
                  }
                }
              } catch (e) {
                invisibleStr = "";
              }

              const hiddenLink = document.createElement("input");
              hiddenLink.type = "hidden";
              hiddenLink.className = "aurea-injected-prop";
              hiddenLink.name = input.name;
              hiddenLink.value = urlVal;
              form.appendChild(hiddenLink);
              AureaLog.info(`Appended direct URL input for file: ${hiddenLink.name} = "${hiddenLink.value}"`);
              input.disabled = true;
            }
          });

          const sellingPlanInputs = form.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]');
          sellingPlanInputs.forEach((input) => {
            input.disabled = true;
            input.value = "";
          });

          if (btn) {
            if (btn.tagName === "INPUT") btn.value = originalValue;
            else btn.innerHTML = originalHTML;
            btn.classList.remove("loading");
            btn.disabled = false;
          }

          AureaLog.success(`=== Dispatched submit event with Variant ID: ${finalVariantId} ===`);
          form._aureaSubmittedWithNewVariant = true;
          const submitEvent = new Event("submit", { bubbles: true, cancelable: true });
          form.dispatchEvent(submitEvent);
        } catch (err) {
          AureaLog.error("Error during form interaction submission flow:", err);
          if (btn) {
            if (btn.tagName === "INPUT") btn.value = originalValue;
            else btn.innerHTML = originalHTML;
            btn.classList.remove("loading");
            btn.disabled = false;
          }
        } finally {
          window._aureaProcessing = false;
        }
        return false;
      };

      document.addEventListener(
        "submit",
        (e) => {
          const form = e.target;
          if (
            form &&
            form.action &&
            (form.action.includes("/cart/add") || form.querySelector('[name="id"]'))
          ) {
            if (document.body.contains(container)) handleFormInteraction(e);
          }
        },
        true
      );

      let _aureaObserverTimeout = null;
      const observer = new MutationObserver(() => {
        if (_aureaObserverTimeout) return;
        _aureaObserverTimeout = setTimeout(() => {
          _aureaObserverTimeout = null;
          if (!document.body.contains(container)) insertContainer();

          let currentId = "";
          const form = AureaUtils.getProductForm();
          if (form) {
            const idInput = form.querySelector('[name="id"]');
            if (idInput) currentId = idInput.value;
          }
          if (currentId && currentId !== window._aureaLastVariantId) {
            window._aureaLastVariantId = currentId;
            updateVisibility();
          }
        }, 200); // Throttle to run at most once every 200ms
      });
      if (form) {
        observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ["value"] });
      }
    }
  };

  // --- 8. INITIALIZATION DELEGATE ---
  function aureaInitAll() {
    AureaCartInterceptor.init();
    AureaDOMProcessor.observeCart();
    AureaOptionsManager.init();
  }

  // Ejecutar inmediatamente para intentar renderizar opciones de forma instantánea
  aureaInitAll();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", aureaInitAll);
  }

  // SPA Navigation listener and DOM Injection Polling
  let aureaBootInterval = setInterval(() => {
    const nativeContainer = document.getElementById('aurea-native-options');
    const isProductPage = window.location.pathname.includes('/products/');
    
    // Si no estamos en una página de producto y no hay contenedor nativo, apagamos el script inmediatamente.
    if (!isProductPage && !nativeContainer) {
      clearInterval(aureaBootInterval);
      return;
    }

    const forms = document.querySelectorAll('form[action*="/cart/add"]:not(.installment)');
    const productId = AureaUtils.getProductId();
    
    if ((forms.length > 0 || nativeContainer) && productId) {
      clearInterval(aureaBootInterval); 
      if (productId) {
        aureaInitAll(); // Renderizar AHORA
      } else {
        // Si por alguna razón el ID no está, reintentar en 10ms
        setTimeout(() => aureaInitAll(), 10);
      }
      
      // Mantener un observer SÓLO para navegaciones SPA (cambiar de producto sin recargar)
      let spaDebounce = null;
      const spaObserver = new MutationObserver(() => {
        if (spaDebounce) clearTimeout(spaDebounce);
        spaDebounce = setTimeout(() => {
          aureaInitAll();
        }, 150);
      });
      spaObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }, 20); // Reducido a 20ms para máxima velocidad

  // Fallback clear
  setTimeout(() => {
    clearInterval(aureaBootInterval);
  }, 10000);

})();
